(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carousel-text"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const carousels = document.querySelectorAll('[data-carousel-text] [data-carousel]');

    carousels.forEach(function(carousel) {
      const slides = carousel.querySelectorAll('.carousel-text__carousel-slide');
      const prevBtn = carousel.querySelector('[data-carousel-prev]');
      const nextBtn = carousel.querySelector('[data-carousel-next]');

      if (slides.length <= 1) return;

      let currentIndex = 0;

      function updateSlides() {
        slides.forEach(function(slide, index) {
          slide.classList.remove(
            'carousel-text__carousel-slide--prev',
            'carousel-text__carousel-slide--active',
            'carousel-text__carousel-slide--next'
          );

          const diff = index - currentIndex;

          if (diff === 0) {
            slide.classList.add('carousel-text__carousel-slide--active');
          } else if (diff === -1 || (currentIndex === 0 && index === slides.length - 1)) {
            slide.classList.add('carousel-text__carousel-slide--prev');
          } else if (diff === 1 || (currentIndex === slides.length - 1 && index === 0)) {
            slide.classList.add('carousel-text__carousel-slide--next');
          }
        });
      }

      function goToSlide(index) {
        if (index < 0) {
          currentIndex = slides.length - 1;
        } else if (index >= slides.length) {
          currentIndex = 0;
        } else {
          currentIndex = index;
        }
        updateSlides();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          goToSlide(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          goToSlide(currentIndex + 1);
        });
      }

      slides.forEach(function(slide, index) {
        slide.addEventListener('click', function() {
          if (index !== currentIndex) {
            goToSlide(index);
          }
        });
      });

      updateSlides();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Variable globale pour synchroniser les chevrons mobiles
  let syncMobileSortChevrons;

  (function () {
    const iconButtons = document.querySelectorAll('[data-icon-trigger]');

    iconButtons.forEach((button) => {
      button.addEventListener('click', function () {
        const iconType = this.getAttribute('data-icon-trigger');
        const box = document.querySelector(`[data-icon-box="${iconType}"]`);
        const isActive = this.classList.contains('active');

        // Fermer toutes les autres boxes et boutons
        document.querySelectorAll('[data-icon-trigger]').forEach((btn) => {
          btn.classList.remove('active');
        });
        document.querySelectorAll('[data-icon-box]').forEach((b) => {
          b.classList.remove('active');
        });

        // Toggle la box actuelle
        if (!isActive) {
          this.classList.add('active');
          box.classList.add('active');
        }
      });
    });

    // Fermer les boxes en cliquant en dehors
    document.addEventListener('click', function (event) {
      if (!event.target.closest('.collection__icon-wrapper')) {
        document.querySelectorAll('[data-icon-trigger]').forEach((btn) => {
          btn.classList.remove('active');
        });
        document.querySelectorAll('[data-icon-box]').forEach((box) => {
          box.classList.remove('active');
        });
      }
    });

    // Gestion du filtrage multiple par type de produit
    const productTypeFilters = document.querySelectorAll('.collection__product-type-filter');
    const products = document.querySelectorAll('.collection__product');
    let activeFilters = new Set();
    let activeArtists = new Set();
    let activeRarities = new Set();

    // Initialiser les filtres depuis l'URL au chargement de la page
    function initializeFiltersFromURL() {
      const urlParams = new URLSearchParams(window.location.search);
      const productTypeParam = urlParams.get('filter.p.product_type');
      const rarityParam = urlParams.get('filter.rarity');
      const artistParam = urlParams.get('filter.artist');

      let hasFilters = false;

      if (productTypeParam) {
        // Ajouter le type de produit au Set des filtres actifs
        activeFilters.add(productTypeParam);

        // Activer le bouton de filtre correspondant (desktop et mobile)
        productTypeFilters.forEach((filter) => {
          if (filter.getAttribute('data-product-type') === productTypeParam) {
            filter.classList.add('active');
          }
        });

        // Activer les filtres mobiles correspondants
        const mobileProductTypeBtns = document.querySelectorAll('.collection__mobile-product-type');
        mobileProductTypeBtns.forEach((btn) => {
          if (btn.getAttribute('data-product-type') === productTypeParam) {
            btn.classList.add('active');
          }
        });

        // Mettre à jour l'état de l'icône Masterpieces
        const masterpiecesButton = document.querySelector('[data-icon-trigger="masterpieces"]');
        if (masterpiecesButton) {
          masterpiecesButton.classList.add('filtered');
        }

        hasFilters = true;
      }

      if (rarityParam) {
        // Ajouter la rareté au Set des filtres actifs
        activeRarities.add(rarityParam);

        // Activer le bouton de filtre de rareté correspondant (desktop)
        const rarityFilters = document.querySelectorAll('.collection__rarity-filter');
        rarityFilters.forEach((filter) => {
          if (filter.getAttribute('data-rarity') === rarityParam) {
            filter.classList.add('active');
          }
        });

        // Activer les filtres mobiles de rareté correspondants
        const mobileRarityBtns = document.querySelectorAll('.collection__mobile-rarity');
        mobileRarityBtns.forEach((btn) => {
          if (btn.getAttribute('data-rarity') === rarityParam) {
            btn.classList.add('active');
          }
        });

        // Mettre à jour l'état de l'icône Rarities
        const raritiesButton = document.querySelector('[data-icon-trigger="rarities"]');
        if (raritiesButton) {
          raritiesButton.classList.add('filtered');
        }

        hasFilters = true;
      }

      if (artistParam) {
        // Ajouter l'artiste au Set des filtres actifs
        activeArtists.add(artistParam);

        // Activer le bouton de filtre d'artiste correspondant (desktop)
        const artistFilters = document.querySelectorAll('.collection__artist-filter');
        artistFilters.forEach((filter) => {
          if (filter.getAttribute('data-artist') === artistParam) {
            filter.classList.add('active');
          }
        });

        // Activer les filtres mobiles d'artiste correspondants
        const mobileArtistBtns = document.querySelectorAll('.collection__mobile-artist');
        mobileArtistBtns.forEach((btn) => {
          if (btn.getAttribute('data-artist') === artistParam) {
            btn.classList.add('active');
          }
        });

        // Mettre à jour l'état de l'icône Artists
        const artistsButton = document.querySelector('[data-icon-trigger="artists"]');
        if (artistsButton) {
          artistsButton.classList.add('filtered');
        }

        hasFilters = true;
      }

      if (hasFilters) {
        // Filtrer les produits
        filterProducts();

        // Nettoyer l'URL pour ne pas qu'elle interfère avec les futurs filtres
        // On remplace l'URL sans les paramètres de filtre, sans recharger la page
        const cleanUrl = window.location.pathname;
        window.history.replaceState({}, document.title, cleanUrl);
      }
    }

    // Appeler l'initialisation au chargement
    initializeFiltersFromURL();

    // Fonction pour filtrer les produits par artistes, types et raretés
    function filterProductsByArtists() {
      if (activeArtists.size === 0 && activeFilters.size === 0 && activeRarities.size === 0) {
        // Aucun filtre actif : afficher tous les produits
        products.forEach((product) => {
          product.classList.remove('hidden');
        });
      } else {
        // Filtres actifs : combiner les filtres de type, artiste et rareté
        products.forEach((product) => {
          const productType = product.getAttribute('data-product-type');
          const productArtist = product.getAttribute('data-product-artist');
          const productRarity = product.getAttribute('data-product-rarity');

          let showProduct = true;

          // Si un filtre de type est actif, le produit doit correspondre
          if (activeFilters.size > 0) {
            showProduct = activeFilters.has(productType);
          }

          // Si un filtre d'artiste est actif, le produit doit correspondre
          if (activeArtists.size > 0 && showProduct) {
            showProduct = activeArtists.has(productArtist);
          }

          // Si un filtre de rareté est actif, le produit doit correspondre
          if (activeRarities.size > 0 && showProduct) {
            showProduct = activeRarities.has(productRarity);
          }

          if (showProduct) {
            product.classList.remove('hidden');
          } else {
            product.classList.add('hidden');
          }
        });
      }
    }

    // Fonction pour filtrer les produits (délègue à filterProductsByArtists)
    function filterProducts() {
      filterProductsByArtists();
    }

    productTypeFilters.forEach((filter) => {
      filter.addEventListener('click', function (event) {
        event.stopPropagation();

        const productType = this.getAttribute('data-product-type');

        // Toggle le filtre
        if (activeFilters.has(productType)) {
          activeFilters.delete(productType);
          this.classList.remove('active');
        } else {
          activeFilters.add(productType);
          this.classList.add('active');
        }

        // Mettre à jour tous les filtres avec le même type (desktop et mobile)
        productTypeFilters.forEach((f) => {
          if (f.getAttribute('data-product-type') === productType) {
            if (activeFilters.has(productType)) {
              f.classList.add('active');
            } else {
              f.classList.remove('active');
            }
          }
        });

        // Mettre à jour les filtres mobiles
        const mobileProductTypeBtns = document.querySelectorAll('.collection__mobile-product-type');
        mobileProductTypeBtns.forEach((btn) => {
          if (btn.getAttribute('data-product-type') === productType) {
            if (activeFilters.has(productType)) {
              btn.classList.add('active');
            } else {
              btn.classList.remove('active');
            }
          }
        });

        // Mettre à jour l'état de l'icône Masterpieces uniquement
        const masterpiecesButton = document.querySelector('[data-icon-trigger="masterpieces"]');
        if (activeFilters.size === 0) {
          masterpiecesButton.classList.remove('filtered');
        } else {
          masterpiecesButton.classList.add('filtered');
        }

        // Filtrer les produits
        filterProducts();
      });
    });

    // Gestion du clic sur le badge de suppression des filtres Masterpieces
    const masterpiecesButton = document.querySelector('[data-icon-trigger="masterpieces"]');
    const deleteFilterBadge = masterpiecesButton?.querySelector('.collection__delete-filter-badge');
    if (deleteFilterBadge) {
      deleteFilterBadge.addEventListener('click', function (event) {
        event.stopPropagation();
        event.preventDefault();

        // Désactiver tous les filtres
        activeFilters.clear();
        productTypeFilters.forEach((f) => f.classList.remove('active'));

        // Désactiver les filtres mobiles
        const mobileProductTypeBtns = document.querySelectorAll('.collection__mobile-product-type');
        mobileProductTypeBtns.forEach((btn) => btn.classList.remove('active'));

        // Retirer la classe filtered de l'icône Masterpieces
        masterpiecesButton.classList.remove('filtered');

        // Réafficher tous les produits
        filterProducts();
      });
    }

    // Gestion du filtrage par artistes
    const artistSearch = document.querySelector('[data-artist-search]');
    const artistCheckboxes = document.querySelectorAll('[data-artist-filter]');
    const artistLabels = document.querySelectorAll('.collection__artist-checkbox-label');

    // Recherche d'artiste dans le textfield
    if (artistSearch) {
      artistSearch.addEventListener('input', function () {
        const searchTerm = this.value.toLowerCase();

        artistLabels.forEach((label) => {
          const artistName = label.querySelector('.collection__artist-name-label').textContent.toLowerCase();
          if (artistName.includes(searchTerm)) {
            label.classList.remove('hidden');
          } else {
            label.classList.add('hidden');
          }
        });
      });
    }

    // Filtrage par checkbox d'artiste
    artistCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', function () {
        const artistValue = this.value;

        if (this.checked) {
          activeArtists.add(artistValue);
        } else {
          activeArtists.delete(artistValue);
        }

        // Mettre à jour l'état de l'icône Artists
        const artistsButton = document.querySelector('[data-icon-trigger="artists"]');
        if (activeArtists.size === 0) {
          artistsButton.classList.remove('filtered');
        } else {
          artistsButton.classList.add('filtered');
        }

        // Mettre à jour le filtrage des produits
        filterProductsByArtists();
      });
    });

    // Gestion du clic sur le badge de suppression des filtres d'artistes
    const artistsButton = document.querySelector('[data-icon-trigger="artists"]');
    const deleteArtistFilterBadge = artistsButton.querySelector('.collection__delete-filter-badge');
    if (deleteArtistFilterBadge) {
      deleteArtistFilterBadge.addEventListener('click', function (event) {
        event.stopPropagation();
        event.preventDefault();

        // Désactiver tous les filtres d'artistes
        activeArtists.clear();
        artistCheckboxes.forEach((cb) => (cb.checked = false));

        // Retirer la classe filtered de l'icône Artists
        artistsButton.classList.remove('filtered');

        // Réafficher les produits filtrés
        filterProductsByArtists();
      });
    }

    // Gestion du filtrage par rareté
    const rarityFilters = document.querySelectorAll('.collection__rarity-filter');

    rarityFilters.forEach((filter) => {
      filter.addEventListener('click', function (event) {
        event.stopPropagation();

        const rarity = this.getAttribute('data-rarity');

        // Toggle le filtre
        if (activeRarities.has(rarity)) {
          activeRarities.delete(rarity);
          this.classList.remove('active');
        } else {
          activeRarities.add(rarity);
          this.classList.add('active');
        }

        // Mettre à jour les filtres mobiles de rareté
        const mobileRarityBtns = document.querySelectorAll('.collection__mobile-rarity');
        mobileRarityBtns.forEach((btn) => {
          if (btn.getAttribute('data-rarity') === rarity) {
            if (activeRarities.has(rarity)) {
              btn.classList.add('active');
            } else {
              btn.classList.remove('active');
            }
          }
        });

        // Mettre à jour l'état de l'icône Rarities
        const raritiesButton = document.querySelector('[data-icon-trigger="rarities"]');
        if (activeRarities.size === 0) {
          raritiesButton.classList.remove('filtered');
        } else {
          raritiesButton.classList.add('filtered');
        }

        // Mettre à jour le filtrage des produits
        filterProductsByArtists();
      });
    });

    // Gestion du clic sur le badge de suppression des filtres de rareté
    const raritiesButton = document.querySelector('[data-icon-trigger="rarities"]');
    const deleteRarityFilterBadge = raritiesButton.querySelector('.collection__delete-filter-badge');
    if (deleteRarityFilterBadge) {
      deleteRarityFilterBadge.addEventListener('click', function (event) {
        event.stopPropagation();
        event.preventDefault();

        // Désactiver tous les filtres de rareté
        activeRarities.clear();
        rarityFilters.forEach((f) => f.classList.remove('active'));

        // Désactiver les filtres mobiles de rareté
        const mobileRarityBtns = document.querySelectorAll('.collection__mobile-rarity');
        mobileRarityBtns.forEach((btn) => btn.classList.remove('active'));

        // Retirer la classe filtered de l'icône Rarities
        raritiesButton.classList.remove('filtered');

        // Réafficher les produits filtrés
        filterProductsByArtists();
      });
    }

    // Gestion du menu de tri
    const settingsBtn = document.querySelector('[data-settings-btn]');
    const settingsMenu = document.querySelector('[data-settings-menu]');

    if (settingsBtn && settingsMenu) {
      settingsBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        settingsMenu.classList.toggle('is-open');
        settingsBtn.classList.toggle('is-active');
      });

      // Fermer le menu si on clique ailleurs
      document.addEventListener('click', function () {
        settingsMenu.classList.remove('is-open');
        settingsBtn.classList.remove('is-active');
      });

      // Empêcher la fermeture si on clique sur le menu
      settingsMenu.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    // Gestion du tri par options
    const sortOptions = document.querySelectorAll('.collection__settings-option');
    const productGrid = document.querySelector('.collection__grid');
    let currentSort = {}; // { type: 'price'|'rarity'|'az', direction: 'down'|'up' }

    // Sauvegarder l'ordre initial des produits au chargement de la page
    let initialProductOrder = [];
    if (productGrid) {
      initialProductOrder = Array.from(productGrid.querySelectorAll('.collection__product'));
    }

    sortOptions.forEach((option) => {
      option.addEventListener('click', function (event) {
        event.stopPropagation();

        const sortType = this.getAttribute('data-sort');
        const chevronUp = this.querySelector('.collection__settings-chevron--up');
        const chevronDown = this.querySelector('.collection__settings-chevron--down');

        // Vérifier l'état actuel de cette option
        const hasActiveChevron =
          chevronUp.classList.contains('is-active') || chevronDown.classList.contains('is-active');

        if (!hasActiveChevron) {
          // Premier clic : activer chevron down (par défaut)
          // Désactiver tous les autres chevrons
          sortOptions.forEach((opt) => {
            opt.querySelectorAll('.collection__settings-chevron').forEach((c) => c.classList.remove('is-active'));
          });

          chevronDown.classList.add('is-active');
          currentSort = { type: sortType, direction: 'down' };
        } else if (chevronDown.classList.contains('is-active')) {
          // Deuxième clic : passer à chevron up
          chevronDown.classList.remove('is-active');
          chevronUp.classList.add('is-active');
          currentSort = { type: sortType, direction: 'up' };
        } else {
          // Troisième clic : revenir à chevron down
          chevronUp.classList.remove('is-active');
          chevronDown.classList.add('is-active');
          currentSort = { type: sortType, direction: 'down' };
        }

        // Synchroniser les chevrons mobiles
        syncMobileSortChevrons();

        // Trier les produits
        sortProducts(currentSort);
      });
    });

    // Fonction pour synchroniser les chevrons mobiles avec les chevrons desktop
    syncMobileSortChevrons = function () {
      // Désactiver tous les chevrons mobiles
      const allMobileChevrons = document.querySelectorAll('.collection__mobile-sort-chevron');
      allMobileChevrons.forEach((c) => c.classList.remove('active'));

      // Activer le chevron mobile correspondant au chevron desktop actif
      sortOptions.forEach((option) => {
        const sortType = option.getAttribute('data-sort');
        const chevronUp = option.querySelector('.collection__settings-chevron--up');
        const chevronDown = option.querySelector('.collection__settings-chevron--down');

        if (chevronUp.classList.contains('is-active')) {
          const mobileOption = document.querySelector(`[data-mobile-sort="${sortType}"]`);
          if (mobileOption) {
            const mobileChevronUp = mobileOption.querySelector('.collection__mobile-sort-chevron--up');
            if (mobileChevronUp) {
              mobileChevronUp.classList.add('active');
            }
          }
        } else if (chevronDown.classList.contains('is-active')) {
          const mobileOption = document.querySelector(`[data-mobile-sort="${sortType}"]`);
          if (mobileOption) {
            const mobileChevronDown = mobileOption.querySelector('.collection__mobile-sort-chevron--down');
            if (mobileChevronDown) {
              mobileChevronDown.classList.add('active');
            }
          }
        }
      });
    };

    function sortProducts(sort) {
      if (!productGrid) return;

      let products = [];

      if (!sort) {
        // Pas de tri, rétablir l'ordre original sauvegardé au chargement
        products = [...initialProductOrder];
      } else {
        products = Array.from(productGrid.querySelectorAll('.collection__product'));
        products.sort((a, b) => {
          let compareValue = 0;

          switch (sort.type) {
            case 'price':
              const priceA = parseFloat(a.getAttribute('data-product-price'));
              const priceB = parseFloat(b.getAttribute('data-product-price'));
              compareValue = priceA - priceB;
              break;

            case 'rarity':
              const rarityOrder = { legendary: 4, epic: 3, rare: 2, common: 1 };
              const rarityA = rarityOrder[a.getAttribute('data-product-rarity')] || 0;
              const rarityB = rarityOrder[b.getAttribute('data-product-rarity')] || 0;
              compareValue = rarityA - rarityB;
              break;

            case 'az':
              const titleA = a.getAttribute('data-product-title') || '';
              const titleB = b.getAttribute('data-product-title') || '';
              compareValue = titleA.localeCompare(titleB);
              break;
          }

          // Inverser si direction down
          return sort.direction === 'down' ? compareValue : -compareValue;
        });
      }

      // Réorganiser le DOM
      products.forEach((product) => {
        productGrid.appendChild(product);
      });

      // Mettre à jour la classe du bouton de tri
      updateSortButtonState();
    }

    // Mettre à jour l'état du bouton de tri
    function updateSortButtonState() {
      const settingsBtn = document.querySelector('[data-settings-btn]');
      if (!settingsBtn) return;

      const hasActiveSort =
        sortOptions &&
        Array.from(sortOptions).some((opt) => {
          const chevronUp = opt.querySelector('.collection__settings-chevron--up');
          const chevronDown = opt.querySelector('.collection__settings-chevron--down');
          return chevronUp?.classList.contains('is-active') || chevronDown?.classList.contains('is-active');
        });

      if (hasActiveSort) {
        settingsBtn.classList.add('has-active-sort');
      } else {
        settingsBtn.classList.remove('has-active-sort');
      }
    }

    // Gérer le clic sur le badge de suppression du tri (desktop)
    const clearSortBadge = document.querySelector('[data-clear-sort]');
    if (clearSortBadge) {
      clearSortBadge.addEventListener('click', function (event) {
        event.stopPropagation();

        // Désactiver tous les chevrons
        sortOptions.forEach((opt) => {
          opt.querySelectorAll('.collection__settings-chevron').forEach((c) => c.classList.remove('is-active'));
        });

        // Synchroniser les chevrons mobiles
        syncMobileSortChevrons();

        // Réinitialiser le tri
        currentSort = {};
        sortProducts(null);

        // Mettre à jour l'état du bouton
        updateSortButtonState();
      });
    }

    // Appeler updateSortButtonState et syncMobileSortChevrons au chargement
    updateSortButtonState();
    syncMobileSortChevrons();
  })();
(function () {
  const productGrid = document.querySelector('.collection__grid');
  
  if (productGrid && !window.location.search.includes('filter')) {
    // Ne trier que si aucun filtre URL n'est présent
    const products = Array.from(productGrid.querySelectorAll('.collection__product'));
    
    // Trier par date de création (timestamp décroissant)
    products.sort((a, b) => {
      const dateA = parseInt(a.getAttribute('data-created-at') || '0');
      const dateB = parseInt(b.getAttribute('data-created-at') || '0');
      return dateB - dateA; // Plus récent en premier
    });
    
    // Réorganiser le DOM
    products.forEach(product => {
      productGrid.appendChild(product);
    });
  }
})();
  // Mobile Filter Bar
  (function () {
    const mobileFilterBtns = document.querySelectorAll('[data-mobile-filter]');
    const mobilePanels = document.querySelectorAll('[data-mobile-panel]');
    const panelCloses = document.querySelectorAll('[data-panel-close]');
    const backdrop = document.querySelector('[data-mobile-filter-backdrop]');

    function closePanels() {
      mobilePanels.forEach((p) => p.classList.remove('active'));
      mobileFilterBtns.forEach((b) => b.classList.remove('active'));
      if (backdrop) {
        backdrop.classList.remove('active');
      }
    }

    // Open panel on filter button click
    mobileFilterBtns.forEach((btn) => {
      btn.addEventListener('click', function () {
        const filterType = this.getAttribute('data-mobile-filter');
        const targetPanel = document.querySelector(`[data-mobile-panel="${filterType}"]`);

        // Close all panels first
        closePanels();

        // Open target panel
        if (targetPanel) {
          targetPanel.classList.add('active');
          if (backdrop) {
            backdrop.classList.add('active');
          }
        }

        // Toggle active state on buttons
        this.classList.add('active');
      });
    });

    // Close panel on X button click
    panelCloses.forEach((closeBtn) => {
      closeBtn.addEventListener('click', function () {
        closePanels();
      });
    });

    // Close panel on backdrop click
    if (backdrop) {
      backdrop.addEventListener('click', function () {
        closePanels();
      });
    }

    // Mobile Product Type filters
    const mobileProductTypeBtns = document.querySelectorAll('.collection__mobile-product-type');
    mobileProductTypeBtns.forEach((btn) => {
      btn.addEventListener('click', function (event) {
        const productType = this.getAttribute('data-product-type');
        const desktopBtn = document.querySelector(
          `.collection__product-type-filter[data-product-type="${productType}"]`
        );

        if (desktopBtn) {
          desktopBtn.click();
        }

        this.classList.toggle('active');
        updateFilterBarButtons();
      });
    });

    // Mobile Rarity filters
    const mobileRarityBtns = document.querySelectorAll('.collection__mobile-rarity');
    mobileRarityBtns.forEach((btn) => {
      btn.addEventListener('click', function (event) {
        const rarity = this.getAttribute('data-rarity');
        const desktopBtn = document.querySelector(`.collection__rarity-filter[data-rarity="${rarity}"]`);

        if (desktopBtn) {
          desktopBtn.click();
        }

        updateFilterBarButtons();
      });
    });

    // Mobile Artist filters
    const mobileArtistCheckboxes = document.querySelectorAll('[data-mobile-artist-filter]');
    mobileArtistCheckboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', function () {
        const artist = this.value;
        const desktopCheckbox = document.querySelector(`.collection__artist-checkbox[value="${artist}"]`);

        if (desktopCheckbox) {
          desktopCheckbox.checked = this.checked;
          desktopCheckbox.dispatchEvent(new Event('change'));
        }
        updateFilterBarButtons();
      });
    });

    // Mobile Artist Search
    const mobileArtistSearch = document.querySelector('[data-mobile-artist-search]');
    if (mobileArtistSearch) {
      mobileArtistSearch.addEventListener('input', function () {
        const searchTerm = this.value.toLowerCase();
        const artistItems = document.querySelectorAll('.collection__mobile-artist-item');

        artistItems.forEach((item) => {
          const artistName = item.textContent.toLowerCase();
          if (artistName.includes(searchTerm)) {
            item.style.display = 'flex';
          } else {
            item.style.display = 'none';
          }
        });
      });
    }

    // Mobile Sort options
    const mobileSortOptions = document.querySelectorAll('[data-mobile-sort]');
    mobileSortOptions.forEach((option) => {
      option.addEventListener('click', function () {
        const sortType = this.getAttribute('data-mobile-sort');
        const desktopSortOption = document.querySelector(`.collection__settings-option[data-sort="${sortType}"]`);

        if (desktopSortOption) {
          desktopSortOption.click();
        }
        updateFilterBarButtons();
      });
    });

    // Mobile Clear Filters buttons (on the filter bar buttons)
    const mobileClearBarBtns = document.querySelectorAll('[data-mobile-clear-bar]');
    mobileClearBarBtns.forEach((btn) => {
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        const clearType = this.getAttribute('data-mobile-clear-bar');

        if (clearType === 'masterpieces') {
          // Clear all product type filters
          const desktopClearBadge = document.querySelector(
            '[data-icon-trigger="masterpieces"] .collection__delete-filter-badge'
          );
          if (desktopClearBadge) {
            desktopClearBadge.click();
          }
        } else if (clearType === 'artists') {
          // Clear all artist filters
          const desktopClearBadge = document.querySelector(
            '[data-icon-trigger="artists"] .collection__delete-filter-badge'
          );
          if (desktopClearBadge) {
            desktopClearBadge.click();
          }
        } else if (clearType === 'rarities') {
          // Clear all rarity filters
          const desktopClearBadge = document.querySelector(
            '[data-icon-trigger="rarities"] .collection__delete-filter-badge'
          );
          if (desktopClearBadge) {
            desktopClearBadge.click();
          }
        } else if (clearType === 'sort') {
          // Clear sorting
          const desktopClearSort = document.querySelector('[data-clear-sort]');
          if (desktopClearSort) {
            desktopClearSort.click();
          }
        }

        updateFilterBarButtons();
      });
    });

    // Function to update filter bar buttons state
    function updateFilterBarButtons() {
      // Update Masterpieces button
      const masterpiecesBtn = document.querySelector('[data-filter-type="masterpieces"]');
      const activeProductTypes = document.querySelectorAll('.collection__mobile-product-type.active');
      if (masterpiecesBtn) {
        if (activeProductTypes.length > 0) {
          masterpiecesBtn.classList.add('has-filters');
        } else {
          masterpiecesBtn.classList.remove('has-filters');
        }
      }

      // Update Artists button
      const artistsBtn = document.querySelector('[data-filter-type="artists"]');
      const activeArtists = document.querySelectorAll('[data-mobile-artist-filter]:checked');
      if (artistsBtn) {
        if (activeArtists.length > 0) {
          artistsBtn.classList.add('has-filters');
        } else {
          artistsBtn.classList.remove('has-filters');
        }
      }

      // Update Rarities button
      const raritiesBtn = document.querySelector('[data-filter-type="rarities"]');
      const activeRarities = document.querySelectorAll('.collection__mobile-rarity.active');
      if (raritiesBtn) {
        if (activeRarities.length > 0) {
          raritiesBtn.classList.add('has-filters');
        } else {
          raritiesBtn.classList.remove('has-filters');
        }
      }

      // Update Sort button
      const sortBtn = document.querySelector('[data-filter-type="sort"]');
      const activeChevrons = document.querySelectorAll('.collection__mobile-sort-chevron.active');
      if (sortBtn) {
        if (activeChevrons.length > 0) {
          sortBtn.classList.add('has-filters');
        } else {
          sortBtn.classList.remove('has-filters');
        }
      }
    }

    // Initial update
    updateFilterBarButtons();
  })();

  // Auto-open Masterpieces filter on page load
  (function () {
    function autoOpenMasterpieces() {
      const masterpiecesTrigger = document.querySelector('[data-icon-trigger="masterpieces"]');
      const masterpiecesBox = document.querySelector('[data-icon-box="masterpieces"]');

      if (masterpiecesTrigger && masterpiecesBox) {
        masterpiecesTrigger.classList.add('active');
        masterpiecesBox.classList.add('active');
      }
    }

    // Call on DOM ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', autoOpenMasterpieces);
    } else {
      autoOpenMasterpieces();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SideNavigation {
    constructor() {
      this.sideNav = document.querySelector('[data-side-nav]');
      this.overlay = document.querySelector('[data-side-nav-overlay]');
      this.triggers = document.querySelectorAll('[data-side-nav-trigger]');
      this.closeBtn = document.querySelector('[data-side-nav-close]');
      this.scrollStar = document.querySelector('[data-scroll-star]');
      this.content = this.sideNav?.querySelector('.side-nav__content');
      this.preview = document.querySelector('[data-side-nav-preview]');
      this.previewCloseBtn = document.querySelector('[data-preview-close]');
      this.previewOpenBtn = document.querySelector('[data-preview-open]');
      this.previewItems = document.querySelectorAll('[data-preview-item]');

      // Preview state
      this.previewManuallyClosed = false;

      // Menu title to product type mapping
      this.menuToTypeMapping = {
        posters: 'poster',
        keycaps: 'keycaps',
        'tapis-de-souris': 'mousepad',
      };

      // Load products data
      this.productsData = this.loadProductsData();

      if (
        this.sideNav &&
        this.overlay &&
        this.triggers.length > 0 &&
        this.closeBtn &&
        this.scrollStar &&
        this.preview
      ) {
        this.init();
      }
    }

    loadProductsData() {
      const dataScript = document.getElementById('preview-products-data');

      try {
        if (!dataScript) {
          console.warn('⚠️ Preview products data script not found');
          return {};
        }

        const rawContent = dataScript.textContent.trim();

        const data = JSON.parse(rawContent);
        return data;
      } catch (error) {
        console.error('❌ Error loading products data:', error);
        console.error('Raw content:', dataScript?.textContent);
        return {};
      }
    }

    init() {
      this.bindEvents();
      this.initCustomScrollbar();
      this.initPreviewEvents();
      this.initImageLightEffect();
    }

    initCustomScrollbar() {
      if (!this.content) return;

      // Update star position on scroll
      this.content.addEventListener('scroll', () => {
        this.updateStarPosition();
      });

      // Initial position
      this.updateStarPosition();
    }

    updateStarPosition() {
      if (!this.content) return;

      const scrollTop = this.content.scrollTop;
      const scrollHeight = this.content.scrollHeight;
      const clientHeight = this.content.clientHeight;

      // Calculate maximum scroll
      const maxScroll = scrollHeight - clientHeight;

      if (maxScroll <= 0) {
        // No scroll needed, keep star at top
        this.scrollStar.style.top = '0px';
        return;
      }

      // Calculate percentage of scroll
      const scrollPercent = scrollTop / maxScroll;

      // Calculate available space for star movement (subtract star height)
      const availableHeight = clientHeight - 50; // 50px is star height

      // Calculate star position
      const starPosition = scrollPercent * availableHeight;

      this.scrollStar.style.top = `${starPosition}px`;
    }

    bindEvents() {
      // Open side navigation - bind to all triggers
      this.triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => this.open(trigger));
      });

      // Close side navigation
      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', () => this.close());

      // Close preview
      if (this.previewCloseBtn) {
        this.previewCloseBtn.addEventListener('click', () => this.hidePreview());
      }

      // Open preview
      if (this.previewOpenBtn) {
        this.previewOpenBtn.addEventListener('click', () => this.openPreview());
      }

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
        }
      });
    }

    open(trigger) {
      this.sideNav.classList.add('is-active');
      this.overlay.classList.add('is-active');
      document.body.classList.add('side-nav-open');

      // Set aria-expanded on all triggers
      this.triggers.forEach((t) => t.setAttribute('aria-expanded', 'true'));

      // Store the trigger that opened the nav for focus return
      this.activeTrigger = trigger;

      // Focus trap - focus on close button
      this.closeBtn.focus();
    }

    close() {
      this.sideNav.classList.remove('is-active');
      this.overlay.classList.remove('is-active');
      document.body.classList.remove('side-nav-open');

      // Set aria-expanded on all triggers
      this.triggers.forEach((t) => t.setAttribute('aria-expanded', 'false'));

      // Hide preview when closing sidenav (automatic close, not manual)
      this.hidePreview(false);

      // Réinitialiser l'état pour la prochaine ouverture du side-nav
      this.previewManuallyClosed = false;

      // Return focus to the trigger that opened it
      if (this.activeTrigger) {
        this.activeTrigger.focus();
      }
    }

    isOpen() {
      return this.sideNav.classList.contains('is-active');
    }

    initPreviewEvents() {
      this.previewItems.forEach((item) => {
        item.addEventListener('mouseenter', (e) => this.showPreview(e.target));
      });
    }

    initImageLightEffect() {
      // Add mouse move event to all preview image wrappers for light effect only
      this.preview.addEventListener('mousemove', (e) => {
        const wrappers = this.preview.querySelectorAll('.side-nav__preview-item .image-wrapper');

        wrappers.forEach((wrapper) => {
          const rect = wrapper.getBoundingClientRect();
          const x = e.clientX - rect.left;
          const y = e.clientY - rect.top;

          // Check if mouse is over this specific wrapper
          if (x >= 0 && x <= rect.width && y >= 0 && y <= rect.height) {
            // Update light position using CSS custom properties
            wrapper.style.setProperty('--light-x', x + 'px');
            wrapper.style.setProperty('--light-y', y + 'px');
            wrapper.classList.add('light-active');
          } else {
            // Remove light effect when mouse is not over the wrapper
            wrapper.classList.remove('light-active');
          }
        });
      });

      // Remove effects when mouse leaves preview area
      this.preview.addEventListener('mouseleave', () => {
        const wrappers = this.preview.querySelectorAll('.side-nav__preview-item .image-wrapper');
        wrappers.forEach((wrapper) => {
          wrapper.classList.remove('light-active');
        });
      });
    }

    showPreview(item) {
      console.log('🔍 Show preview called - isOpen:', this.isOpen());
      if (!this.isOpen()) return;

      // Don't show preview on mobile (screen width <= 768px)
      if (window.innerWidth <= 768) {
        console.log('📱 Mobile detected, preview disabled');
        return;
      }

      // Ne pas ouvrir le drawer si il a été fermé manuellement
      if (this.previewManuallyClosed) return;

      const itemTitle = item.textContent.trim();
      let tag = item.dataset.tag;
      const previewContent = this.preview.querySelector('.side-nav__preview-content');

      // Apply mapping if exists
      if (this.menuToTypeMapping[tag]) {
        tag = this.menuToTypeMapping[tag];
        console.log('📋 Mapped tag:', item.dataset.tag, '→', tag);
      }

      console.log('  - Title:', itemTitle);
      console.log('  - Tag:', tag);
      console.log('  - Data for this tag:', this.productsData[tag]);

      // Check if there are products to display
      const tagData = this.productsData[tag];
      if (!tagData || !tagData.products || tagData.products.length === 0) {
        console.log('⚠️ No products found for this tag, not opening preview');
        // If preview is already open, close it automatically (not manually)
        if (this.preview.classList.contains('is-active')) {
          this.hidePreview(false); // false = fermeture automatique
        }
        // Don't open preview if no products
        return;
      }

      // First, show the preview zone if not already visible
      if (!this.preview.classList.contains('is-active')) {
        this.preview.classList.add('is-active');

        // Load content
        const html = this.generateProductsHTML(itemTitle, tag);
        previewContent.innerHTML = html;

        // Fade in with a small delay
        setTimeout(() => {
          previewContent.classList.add('is-loaded');
          this.animatePreviewItems(previewContent);
        }, 100);
        return;
      }

      // Fade out current content
      previewContent.classList.remove('is-loaded');

      // Update content after fade out
      setTimeout(() => {
        const html = this.generateProductsHTML(itemTitle, tag);
        previewContent.innerHTML = html;

        // Fade in new content
        setTimeout(() => {
          previewContent.classList.add('is-loaded');
          this.animatePreviewItems(previewContent);
        }, 100);
      }, 300); // Duration of fade out
    }

    generateProductsHTML(title, tag) {
      // Get products for this tag from the data structure
      const tagData = this.productsData[tag];

      if (!tagData || !tagData.products || tagData.products.length === 0) {
        const noResultsText = this.sideNav.dataset.noResultsText || 'No matching results';
        return `
          <div style="display: flex; align-items: center; justify-content: center; height: 100%; color: #f6f6f6; opacity: 0.7; text-align: center; padding: 2rem;">
            <p style="font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; font-size: 14px; line-height: 1.6;">${noResultsText}</p>
          </div>
        `;
      }

      // Get the 2 most recent products (sorted by publishedAt descending)
      const filteredProducts = [...tagData.products]
        .sort((a, b) => (b.publishedAt || 0) - (a.publishedAt || 0))
        .slice(0, 2);
      console.log('✅ Found products:', filteredProducts);

      const productsHTML = filteredProducts
        .map(
          (product, index) => `
        <div class="side-nav__preview-item" style="margin-bottom: ${
          index === filteredProducts.length - 1 ? '0' : '80px'
        };">
          <a href="${product.url}" style="text-decoration: none; color: inherit; display: block;">
            ${
              product.image
                ? `
              <div class="image-wrapper" data-preview-image-wrapper style="position: relative; display: inline-block; width: 300px; height: 335px;">
                <div class="preview-image-background" style="position: absolute; inset: 0; background-size: cover; background-position: center; filter: blur(20px); opacity: 0; transition: opacity 0.3s ease; border: solid 1px #c6b289;"></div>
                <img src="${product.image}" alt="${product.title}"
                     data-image-width="${product.imageWidth}"
                     data-image-height="${product.imageHeight}"
                     style="width: 300px; height: 335px; object-fit: cover; display: block; position: relative; z-index: 2;">
              </div>
            `
                : ''
            }
            <div class="side-nav__preview-title">${product.title}</div>
          </a>
        </div>
      `
        )
        .join('');

      return `
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; box-sizing: border-box;">
          ${productsHTML}
        </div>
      `;
    }

    animatePreviewItems(previewContent) {
      // Get all preview items and make them visible with opacity
      const items = previewContent.querySelectorAll('.side-nav__preview-item');
      items.forEach((item) => {
        item.classList.add('is-visible');
      });

      // Check image orientation after animation
      this.checkPreviewImageOrientation();
    }

    checkPreviewImageOrientation() {
      const imageWrappers = document.querySelectorAll('[data-preview-image-wrapper]');

      imageWrappers.forEach((wrapper) => {
        const img = wrapper.querySelector('img');
        const background = wrapper.querySelector('.preview-image-background');

        if (!img) return;

        const width = parseInt(img.getAttribute('data-image-width'));
        const height = parseInt(img.getAttribute('data-image-height'));

        // Si l'image est horizontale (largeur > hauteur)
        if (width > height) {
          wrapper.classList.add('image-wrapper--horizontal');
          // Définir l'image de fond
          if (background) {
            background.style.backgroundImage = `url(${img.src})`;
            background.style.opacity = '1';
          }
          img.style.objectFit = 'contain';
        } else {
          wrapper.classList.remove('image-wrapper--horizontal');
          if (background) {
            background.style.opacity = '0';
          }
          img.style.objectFit = 'cover';
        }
      });
    }

    openPreview() {
      if (!this.isOpen()) return;

      // Réinitialiser l'état de fermeture manuelle
      this.previewManuallyClosed = false;

      this.preview.classList.add('is-active');
    }

    hidePreview(isManual = true) {
      const previewContent = this.preview.querySelector('.side-nav__preview-content');

      // Remove is-visible class from all items
      const items = previewContent.querySelectorAll('.side-nav__preview-item');
      items.forEach((item) => {
        item.classList.remove('is-visible');
      });

      previewContent.classList.remove('is-loaded');
      this.preview.classList.remove('is-active');

      // Marquer le drawer comme fermé manuellement uniquement si c'est une fermeture manuelle
      if (isManual) {
        this.previewManuallyClosed = true;
      }
    }
  }

  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    new SideNavigation();
  });

  // Cart Drawer
  class CartDrawer {
    constructor() {
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-cart-drawer-overlay]');
      this.trigger = document.querySelector('[data-cart-drawer-trigger]');
      this.closeBtn = document.querySelector('[data-cart-drawer-close]');
      this.timer = document.querySelector('[data-cart-timer]');

      // Timer variables
      this.timeLeft = 15 * 60; // 15 minutes in seconds
      this.timerInterval = null;

      // Get free shipping threshold from section settings (in euros, convert to cents)
      const header = document.querySelector('header[data-free-shipping-threshold]');
      const thresholdInEuros = header ? parseFloat(header.dataset.freeShippingThreshold) : 51;
      this.freeShippingThreshold = thresholdInEuros * 100; // Convert to cents

      if (this.drawer && this.overlay && this.trigger && this.closeBtn) {
        this.init();
      }
    }

    init() {
      this.bindEvents();
      this.listenForCartUpdates();
      this.updateFreeShippingProgress();
    }

    bindEvents() {
      // Open drawer
      this.trigger.addEventListener('click', () => this.open());

      // Close drawer
      this.closeBtn.addEventListener('click', () => this.close());
      this.overlay.addEventListener('click', () => this.close());

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.close();
        }
      });

      // Quantity buttons
      document.querySelectorAll('[data-qty-increase]').forEach((btn) => {
        btn.addEventListener('click', () => this.updateQuantity(btn.dataset.qtyIncrease, 1));
      });

      document.querySelectorAll('[data-qty-decrease]').forEach((btn) => {
        btn.addEventListener('click', () => this.updateQuantity(btn.dataset.qtyDecrease, -1));
      });

      // Remove item buttons
      document.querySelectorAll('[data-remove-item]').forEach((btn) => {
        btn.addEventListener('click', () => this.removeItem(btn.dataset.removeItem));
      });

      // Add to cart buttons in suggestions
      this.bindSuggestionButtons();

      // Discount code
      this.bindDiscountEvents();

      // Image zoom modal (mobile only)
      this.bindImageZoomEvents();
    }

    bindImageZoomEvents() {
      const modal = document.querySelector('[data-image-modal]');
      const modalImg = document.querySelector('[data-image-modal-img]');
      const closeButtons = document.querySelectorAll('[data-image-modal-close]');

      if (!modal || !modalImg) return;

      // Bind click on images
      document.querySelectorAll('[data-image-zoom-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
          // Only work on mobile (max-width: 1024px)
          if (window.innerWidth > 1024) return;

          const img = trigger.querySelector('img');
          if (!img) return;

          const fullImageUrl = img.dataset.fullImage || img.src;
          modalImg.src = fullImageUrl;
          modal.classList.add('is-active');
        });
      });

      // Close modal
      closeButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          modal.classList.remove('is-active');
          modalImg.src = '';
        });
      });

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-active')) {
          modal.classList.remove('is-active');
          modalImg.src = '';
        }
      });
    }

    bindDiscountEvents() {
      const discountInput = document.querySelector('[data-discount-input]');
      const discountBtn = document.querySelector('[data-discount-apply]');

      if (discountInput && discountBtn) {
        discountBtn.addEventListener('click', () => this.applyDiscountCode());
        discountInput.addEventListener('keydown', (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            this.applyDiscountCode();
          }
        });
      }
    }

    async applyDiscountCode() {
      const discountInput = document.querySelector('[data-discount-input]');
      const discountBtn = document.querySelector('[data-discount-apply]');
      const discountMessage = document.querySelector('[data-discount-message]');
      const discountResult = document.querySelector('[data-discount-result]');
      const discountValue = document.querySelector('[data-discount-value]');
      const discountCode = document.querySelector('[data-discount-code]');
      const checkoutLink = document.querySelector('[data-checkout-link]');

      const code = discountInput.value.trim();
      if (!code) {
        this.showDiscountMessage('Veuillez entrer un code promo', 'error');
        return;
      }

      discountBtn.disabled = true;
      discountBtn.textContent = '...';

      try {
        // Apply discount via /discount/CODE URL
        await fetch(`/discount/${encodeURIComponent(code)}`, {
          method: 'GET',
          redirect: 'follow'
        });

        // Fetch the cart to see what changed
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        // Check if the discount code is applicable via discount_codes array
        const discountCodeEntry = cart.discount_codes?.find(dc => dc.code.toLowerCase() === code.toLowerCase());
        const isApplicable = discountCodeEntry?.applicable === true;

        if (!isApplicable) {
          // Code is not applicable - show error
          this.showDiscountMessage('Code promo invalide ou non applicable', 'error');
          if (discountResult) {
            discountResult.style.display = 'none';
          }
          return;
        }

        // Code is applicable - update checkout link
        if (checkoutLink) {
          checkoutLink.href = `/checkout?discount=${encodeURIComponent(code)}`;
        }

        // Hide error message if previously shown
        if (discountMessage) {
          discountMessage.style.display = 'none';
        }

        // Reload the entire drawer to update prices and discount display
        await this.reloadDrawer(false);

        // Update cart total
        this.updateCartTotal(cart);

      } catch (error) {
        this.showDiscountMessage('Erreur lors de l\'application du code', 'error');
        const discountResult = document.querySelector('[data-discount-result]');
        if (discountResult) {
          discountResult.style.display = 'none';
        }
      } finally {
        const discountBtnAfter = document.querySelector('[data-discount-apply]');
        if (discountBtnAfter) {
          discountBtnAfter.disabled = false;
          discountBtnAfter.textContent = 'Appliquer';
        }
      }
    }

    showDiscountMessage(message, type) {
      const discountMessage = document.querySelector('[data-discount-message]');
      if (discountMessage) {
        discountMessage.textContent = message;
        discountMessage.className = 'cart-drawer__discount-message';
        discountMessage.classList.add(`cart-drawer__discount-message--${type}`);
        discountMessage.style.display = 'block';
      }
    }

    bindSuggestionButtons() {
      document.querySelectorAll('[data-add-to-cart]').forEach((btn) => {
        btn.addEventListener('click', () => this.addToCart(btn.dataset.addToCart));
      });
    }

    open() {
      this.drawer.classList.add('is-active');
      this.overlay.classList.add('is-active');
      document.body.classList.add('cart-drawer-open');
      this.startTimer();
    }

    close() {
      this.drawer.classList.remove('is-active');
      this.overlay.classList.remove('is-active');
      document.body.classList.remove('cart-drawer-open');
      this.stopTimer();
    }

    isOpen() {
      return this.drawer.classList.contains('is-active');
    }

    startTimer() {
      // Reset timer if already running
      if (this.timerInterval) {
        this.stopTimer();
      }

      // Get saved time from localStorage or use default
      const savedTime = localStorage.getItem('cart_timer');
      if (savedTime) {
        this.timeLeft = parseInt(savedTime);
      } else {
        this.timeLeft = 15 * 60; // 15 minutes
      }

      this.updateTimerDisplay();

      this.timerInterval = setInterval(() => {
        this.timeLeft--;

        if (this.timeLeft <= 0) {
          this.stopTimer();
          this.timeLeft = 0;
        }

        this.updateTimerDisplay();
        localStorage.setItem('cart_timer', this.timeLeft);
      }, 1000);
    }

    stopTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    }

    updateTimerDisplay() {
      const minutes = Math.floor(this.timeLeft / 60);
      const seconds = this.timeLeft % 60;
      const display = `${minutes}:${seconds.toString().padStart(2, '0')}`;

      if (this.timer) {
        this.timer.textContent = display;
      }
    }

    async updateQuantity(key, change) {
      try {
        // Get current quantity
        const itemElement = document.querySelector(`[data-cart-item="${key}"]`);
        const qtyElement = itemElement.querySelector('.cart-drawer__qty-value');
        const currentQty = parseInt(qtyElement.textContent);
        const newQty = currentQty + change;

        // Don't allow quantity to go below 1
        if (newQty < 1) {
          return;
        }

        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: newQty,
          }),
        });

        if (response.ok) {
          const cart = await response.json();

          // Update quantity display
          qtyElement.textContent = newQty;

          // Update cart total
          this.updateCartTotal(cart);

          // Update cart count in header
          this.updateCartCount(cart.item_count);
        }
      } catch (error) {
        console.error('Error updating quantity:', error);
      }
    }

    async removeItem(key) {
      // Optimistic UI: remove immediately before the API call
      const itemElement = document.querySelector(`[data-cart-item="${key}"]`);
      if (itemElement) {
        itemElement.remove();
      }

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: 0,
          }),
        });

        if (response.ok) {
          const cart = await response.json();

          // Update cart total
          this.updateCartTotal(cart);

          // Update cart count in header
          this.updateCartCount(cart.item_count);

          // Show empty message if cart is empty
          if (cart.item_count === 0) {
            const itemsContainer = this.drawer.querySelector('.cart-drawer__items');
            const emptyText = this.drawer.dataset.emptyText || 'Your cart is empty';
            itemsContainer.innerHTML = `<p class="cart-drawer__empty">${emptyText}</p>`;
          }
        } else {
          // Revert on error: reload drawer to restore actual state
          await this.reloadDrawer(false);
        }
      } catch (error) {
        console.error('Error removing item:', error);
        await this.reloadDrawer(false);
      }
    }

    async addToCart(variantId) {
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
          }),
        });

        if (response.ok) {
          const item = await response.json();

          // Fetch updated cart
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          // Reload drawer content
          await this.reloadDrawerContent();

          // Update cart count in header
          this.updateCartCount(cart.item_count);

          // Update cart total and free shipping progress
          this.updateCartTotal(cart);
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      }
    }

    async reloadDrawerContent() {
      try {
        // Fetch the header section HTML to get updated cart drawer content
        const timestamp = Date.now();
        const response = await fetch(`${window.location.pathname}?section_id=header&_=${timestamp}`, {
          cache: 'no-store'
        });

        if (response.ok) {
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Get the new drawer items
          const newDrawer = doc.querySelector('[data-cart-drawer]');

          if (newDrawer && this.drawer) {
            // Update only the items container
            const newItemsContainer = newDrawer.querySelector('.cart-drawer__items');
            const currentItemsContainer = this.drawer.querySelector('.cart-drawer__items');

            if (newItemsContainer && currentItemsContainer) {
              currentItemsContainer.innerHTML = newItemsContainer.innerHTML;
            }

            // Re-bind quantity and remove buttons
            this.drawer.querySelectorAll('[data-qty-increase]').forEach((btn) => {
              btn.addEventListener('click', () => this.updateQuantity(btn.dataset.qtyIncrease, 1));
            });

            this.drawer.querySelectorAll('[data-qty-decrease]').forEach((btn) => {
              btn.addEventListener('click', () => this.updateQuantity(btn.dataset.qtyDecrease, -1));
            });

            this.drawer.querySelectorAll('[data-remove-item]').forEach((btn) => {
              btn.addEventListener('click', () => this.removeItem(btn.dataset.removeItem));
            });
          }
        }
      } catch (error) {
        console.error('Error reloading drawer content:', error);
      }
    }

    updateCartTotal(cart) {
      console.log('updateCartTotal called with cart.total_price:', cart.total_price);
      const totalElement = document.querySelector('[data-cart-total]');
      if (totalElement) {
        // Format price (assuming price is in cents)
        const formattedPrice = (cart.total_price / 100).toFixed(2).replace('.', ',');
        totalElement.textContent = formattedPrice + '€';
      }
      // Update free shipping progress when cart total changes
      this.updateFreeShippingProgress(cart.total_price);
    }

    updateFreeShippingProgress(cartTotal = null) {
      const progressFillEl = document.querySelector('[data-progress-fill]');
      const freeShippingTextEl = document.querySelector('[data-free-shipping-text]');

      if (!progressFillEl || !freeShippingTextEl) {
        console.log('Missing elements, returning early');
        return;
      }

      // Get cart total if not provided
      if (cartTotal === null) {
        fetch('/cart.js')
          .then((response) => response.json())
          .then((cart) => {
            this.updateFreeShippingProgressDisplay(
              cart.total_price,
              this.freeShippingThreshold,
              progressFillEl,
              freeShippingTextEl
            );
          })
          .catch((error) => console.error('Error fetching cart:', error));
      } else {
        this.updateFreeShippingProgressDisplay(
          cartTotal,
          this.freeShippingThreshold,
          progressFillEl,
          freeShippingTextEl
        );
      }
    }

    updateFreeShippingProgressDisplay(cartTotal, threshold, progressFillEl, textEl) {
      const remaining = threshold - cartTotal;
      const progressPercentage = Math.min((cartTotal / threshold) * 100, 100);

      if (remaining > 0) {
        const formattedRemaining = (remaining / 100).toFixed(2).replace('.', ',');
        textEl.innerHTML = `Plus que <span data-remaining-amount>${formattedRemaining}</span>€ et la livraison est offerte !`;
      } else {
        textEl.textContent = 'Livraison gratuite offerte !';
      }

      progressFillEl.style.width = `${progressPercentage}%`;
    }

    updateCartCount(count) {
      const cartCount = document.querySelector('[data-cart-count]');
      if (cartCount) {
        cartCount.textContent = count;
        if (count > 0) {
          cartCount.style.display = 'flex';
        } else {
          cartCount.style.display = 'none';
        }
      }
    }

    listenForCartUpdates() {
      document.addEventListener('cart:updated', (event) => {
        const shouldOpen = event.detail?.openDrawer || false;
        this.reloadDrawer(shouldOpen);
      });
    }

    async reloadDrawer(shouldOpen = false) {
      try {
        // Fetch the header section HTML to get updated cart drawer content
        // Add cache-busting timestamp to ensure fresh data
        const timestamp = Date.now();
        const response = await fetch(`${window.location.pathname}?section_id=header&_=${timestamp}`, {
          cache: 'no-store'
        });

        if (response.ok) {
          const html = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          // Get the new drawer content
          const newDrawer = doc.querySelector('[data-cart-drawer]');

          // Mettre à jour le badge de count depuis le HTML rechargé
          const newCartCount = doc.querySelector('[data-cart-count]');
          const currentCartCount = document.querySelector('[data-cart-count]');
          if (newCartCount && currentCartCount) {
            currentCartCount.textContent = newCartCount.textContent;
            currentCartCount.dataset.cartCount = newCartCount.dataset.cartCount;
          } else if (!newCartCount && currentCartCount) {
            // Le panier est vide — cacher le badge
            this.updateCartCount(0);
          }

          if (newDrawer && this.drawer) {
            // Replace the drawer content
            this.drawer.innerHTML = newDrawer.innerHTML;

            // Re-bind events for the new elements
            this.closeBtn = this.drawer.querySelector('[data-cart-drawer-close]');
            this.timer = this.drawer.querySelector('[data-cart-timer]');

            // Re-bind close button
            if (this.closeBtn) {
              this.closeBtn.addEventListener('click', () => this.close());
            }

            // Re-bind quantity and remove buttons
            this.drawer.querySelectorAll('[data-qty-increase]').forEach((btn) => {
              btn.addEventListener('click', () => this.updateQuantity(btn.dataset.qtyIncrease, 1));
            });

            this.drawer.querySelectorAll('[data-qty-decrease]').forEach((btn) => {
              btn.addEventListener('click', () => this.updateQuantity(btn.dataset.qtyDecrease, -1));
            });

            this.drawer.querySelectorAll('[data-remove-item]').forEach((btn) => {
              btn.addEventListener('click', () => this.removeItem(btn.dataset.removeItem));
            });

            // Re-bind suggestion buttons
            this.bindSuggestionButtons();

            // Re-bind discount code events
            this.bindDiscountEvents();

            // Re-bind image zoom events
            this.bindImageZoomEvents();

            // Update free shipping progress after reloading drawer
            this.updateFreeShippingProgress();

            // Open drawer if requested
            if (shouldOpen) {
              this.open();
            }
          }
        }
      } catch (error) {
        console.error('Error reloading cart drawer:', error);
      }
    }
  }

  // Cart Suggestions Panel class
  class CartSuggestions {
    constructor() {
      this.panel = document.querySelector('[data-cart-suggestions]');
      this.toggleBtn = document.querySelector('[data-suggestions-toggle]');
      this.reopenBtn = document.querySelector('[data-suggestions-reopen]');
      this.cartDrawer = document.querySelector('[data-cart-drawer]');

      if (this.panel && this.toggleBtn) {
        this.init();
      }
    }

    init() {
      this.bindEvents();
      this.updateCartDrawerState();
      this.bindAddToCartForms();
    }

    bindEvents() {
      this.toggleBtn.addEventListener('click', () => {
        this.toggle();
        this.updateCartDrawerState();
      });

      if (this.reopenBtn) {
        this.reopenBtn.addEventListener('click', () => {
          this.show();
          this.updateCartDrawerState();
        });
      }
    }

    bindAddToCartForms() {
      const forms = this.panel.querySelectorAll('.cart-suggestions__form');
      forms.forEach((form) => {
        form.addEventListener('submit', (e) => this.handleAddToCart(e));
      });
    }

    async handleAddToCart(e) {
      e.preventDefault();

      const form = e.target;
      const submitBtn = form.querySelector('.cart-suggestions__add-to-cart');
      const formData = new FormData(form);

      // Disable button during request
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.5';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: 1,
          }),
        });

        if (response.ok) {
          // Trigger cart update event
          document.dispatchEvent(new CustomEvent('cart:updated'));

          // Open cart drawer to show the added product
          const cartDrawerInstance = window.cartDrawerInstance;
          if (cartDrawerInstance) {
            cartDrawerInstance.open();
          }
        } else {
          console.error('Error adding to cart:', await response.text());
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      } finally {
        // Re-enable button
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.style.opacity = '1';
        }
      }
    }

    updateCartDrawerState() {
      if (this.cartDrawer) {
        if (this.panel.classList.contains('is-hidden')) {
          this.cartDrawer.classList.add('show-suggestions-toggle');
        } else {
          this.cartDrawer.classList.remove('show-suggestions-toggle');
        }
      }
    }

    toggle() {
      this.panel.classList.toggle('is-hidden');
    }

    show() {
      this.panel.classList.remove('is-hidden');
    }

    hide() {
      this.panel.classList.add('is-hidden');
    }
  }

  // Mobile Suggestions Carousel class
  class MobileSuggestionsCarousel {
    constructor() {
      this.carousel = document.querySelector('[data-suggestions-carousel]');
      this.track = document.querySelector('[data-suggestions-track]');
      this.dotsContainer = document.querySelector('[data-suggestions-dots]');

      if (!this.carousel || !this.track) {
        return;
      }

      this.items = Array.from(this.track.querySelectorAll('.cart-drawer__mobile-suggestion-item'));
      this.currentIndex = 0;
      this.autoPlayInterval = null;

      if (this.items.length > 0) {
        this.init();
      }
    }

    init() {
      this.createDots();
      this.bindEvents();
      this.bindAddToCartForms();
      this.startAutoPlay();
    }

    createDots() {
      if (!this.dotsContainer) return;

      this.dotsContainer.innerHTML = '';
      this.items.forEach((_, index) => {
        const dot = document.createElement('div');
        dot.classList.add('cart-drawer__mobile-suggestions-dot');
        if (index === 0) {
          dot.classList.add('active');
        }
        dot.addEventListener('click', () => {
          this.goToSlide(index);
          this.resetAutoPlay();
        });
        this.dotsContainer.appendChild(dot);
      });
      this.dots = Array.from(this.dotsContainer.querySelectorAll('.cart-drawer__mobile-suggestions-dot'));
    }

    bindEvents() {
      // Touch/swipe support
      let startX = 0;
      let currentX = 0;
      let isDragging = false;

      this.carousel.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        this.stopAutoPlay();
      });

      this.carousel.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        currentX = e.touches[0].clientX;
      });

      this.carousel.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;

        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
        }
        this.resetAutoPlay();
      });

      // Mouse drag support for desktop
      this.carousel.addEventListener('mousedown', (e) => {
        startX = e.clientX;
        isDragging = true;
        this.stopAutoPlay();
      });

      this.carousel.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        currentX = e.clientX;
      });

      this.carousel.addEventListener('mouseup', () => {
        if (!isDragging) return;
        isDragging = false;

        const diff = startX - currentX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
        }
        this.resetAutoPlay();
      });

      this.carousel.addEventListener('mouseleave', () => {
        isDragging = false;
      });
    }

    bindAddToCartForms() {
      const forms = this.track.querySelectorAll('.cart-drawer__mobile-suggestion-form');
      forms.forEach((form) => {
        form.addEventListener('submit', (e) => this.handleAddToCart(e));
      });
    }

    async handleAddToCart(e) {
      e.preventDefault();

      const form = e.target;
      const submitBtn = form.querySelector('.cart-drawer__mobile-suggestion-add');
      const formData = new FormData(form);

      // Disable button during request
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.style.opacity = '0.5';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: 1,
          }),
        });

        if (response.ok) {
          // Trigger cart update event
          document.dispatchEvent(new CustomEvent('cart:updated'));
        } else {
          console.error('Error adding to cart:', await response.text());
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      } finally {
        // Re-enable button
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.style.opacity = '1';
        }
      }
    }

    goToSlide(index) {
      this.currentIndex = index;
      const offset = -index * 100;
      this.track.style.transform = `translateX(${offset}%)`;
      this.updateDots();
    }

    next() {
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
      this.goToSlide(this.currentIndex);
    }

    prev() {
      this.currentIndex = (this.currentIndex - 1 + this.items.length) % this.items.length;
      this.goToSlide(this.currentIndex);
    }

    updateDots() {
      if (!this.dots) return;
      this.dots.forEach((dot, index) => {
        if (index === this.currentIndex) {
          dot.classList.add('active');
        } else {
          dot.classList.remove('active');
        }
      });
    }

    startAutoPlay() {
      this.autoPlayInterval = setInterval(() => {
        this.next();
      }, 5000); // Change slide every 5 seconds
    }

    stopAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
    }

    resetAutoPlay() {
      this.stopAutoPlay();
      this.startAutoPlay();
    }
  }

  // Initialize cart drawer and suggestions when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    window.cartDrawerInstance = new CartDrawer();
    new CartSuggestions();
    new MobileSuggestionsCarousel();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  class HeroBannerLight {
    constructor() {
      this.heroImageContainer = document.querySelector('.hero-banner__image');
      if (this.heroImageContainer) {
        this.init();
      }
    }

    init() {
      // Light effect on mousemove
      this.heroImageContainer.addEventListener('mousemove', (e) => {
        const rect = this.heroImageContainer.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        // Update light position
        this.heroImageContainer.style.setProperty('--light-x', `${x}px`);
        this.heroImageContainer.style.setProperty('--light-y', `${y}px`);
        this.heroImageContainer.classList.add('light-active');
      });

      this.heroImageContainer.addEventListener('mouseleave', () => {
        this.heroImageContainer.classList.remove('light-active');
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new HeroBannerLight();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["icon-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const iconBars = document.querySelectorAll('[data-icon-bar]');

    iconBars.forEach(function(iconBar) {
      const carousel = iconBar.querySelector('[data-icon-carousel]');
      const track = iconBar.querySelector('[data-icon-carousel-track]');
      const slides = iconBar.querySelectorAll('.icon-bar__carousel-slide');

      if (!carousel || !track || slides.length <= 1) return;

      let currentIndex = 0;
      let autoPlayInterval;
      const autoPlayDelay = 3000;

      function goToSlide(index) {
        if (index < 0) {
          currentIndex = slides.length - 1;
        } else if (index >= slides.length) {
          currentIndex = 0;
        } else {
          currentIndex = index;
        }

        track.style.transform = 'translateX(-' + (currentIndex * 100) + '%)';
      }

      function startAutoPlay() {
        stopAutoPlay();
        autoPlayInterval = setInterval(function() {
          goToSlide(currentIndex + 1);
        }, autoPlayDelay);
      }

      function stopAutoPlay() {
        if (autoPlayInterval) {
          clearInterval(autoPlayInterval);
        }
      }

      // Touch/swipe support
      let touchStartX = 0;
      let touchEndX = 0;

      carousel.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
        stopAutoPlay();
      }, { passive: true });

      carousel.addEventListener('touchend', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            goToSlide(currentIndex + 1);
          } else {
            goToSlide(currentIndex - 1);
          }
        }
        startAutoPlay();
      }, { passive: true });

      // Start autoplay only on mobile
      function checkMobile() {
        if (window.innerWidth <= 768) {
          startAutoPlay();
        } else {
          stopAutoPlay();
        }
      }

      checkMobile();
      window.addEventListener('resize', checkMobile);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');

    // Ouvrir le premier accordéon par défaut
    if (accordionTriggers.length > 0) {
      const firstTrigger = accordionTriggers[0];
      const firstTriggerId = firstTrigger.getAttribute('data-accordion-trigger');
      const firstContent = document.querySelector(`[data-accordion-content="${firstTriggerId}"]`);

      if (firstContent) {
        firstContent.classList.add('open');
        firstTrigger.classList.add('active');
      }
    }

    accordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function () {
        const triggerId = this.getAttribute('data-accordion-trigger');
        const content = document.querySelector(`[data-accordion-content="${triggerId}"]`);
        const isOpen = content.classList.contains('open');

        // Toggle current accordion only
        if (isOpen) {
          content.classList.remove('open');
          this.classList.remove('active');
        } else {
          content.classList.add('open');
          this.classList.add('active');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const carousels = document.querySelectorAll('[data-image-carousel]');

    carousels.forEach(function(carousel) {
      const slides = carousel.querySelectorAll('.image-carousel__slide');
      const prevBtn = carousel.querySelector('[data-carousel-prev]');
      const nextBtn = carousel.querySelector('[data-carousel-next]');

      if (slides.length <= 1) return;

      let currentIndex = 0;

      function updateSlides() {
        slides.forEach(function(slide, index) {
          slide.classList.remove(
            'image-carousel__slide--prev',
            'image-carousel__slide--active',
            'image-carousel__slide--next'
          );

          const diff = index - currentIndex;

          if (diff === 0) {
            slide.classList.add('image-carousel__slide--active');
          } else if (diff === -1 || (currentIndex === 0 && index === slides.length - 1)) {
            slide.classList.add('image-carousel__slide--prev');
          } else if (diff === 1 || (currentIndex === slides.length - 1 && index === 0)) {
            slide.classList.add('image-carousel__slide--next');
          }
        });
      }

      function goToSlide(index) {
        if (index < 0) {
          currentIndex = slides.length - 1;
        } else if (index >= slides.length) {
          currentIndex = 0;
        } else {
          currentIndex = index;
        }
        updateSlides();
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          goToSlide(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          goToSlide(currentIndex + 1);
        });
      }

      // Click on slide: activate if not active; follow link if active and has link
      slides.forEach(function(slide, index) {
        slide.addEventListener('click', function() {
          if (index !== currentIndex) {
            goToSlide(index);
          } else {
            var link = slide.dataset.slideLink;
            if (link) window.location.href = link;
          }
        });
      });

      // Initialize
      updateSlides();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["master-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // Gestion des filtres de raretés
    let activeRarities = new Set();
    const products = document.querySelectorAll('.collection__product');
    const rarityFilters = document.querySelectorAll('.master-page__rarity-filter');

    function filterProducts() {
      if (activeRarities.size === 0) {
        // Aucun filtre actif : afficher tous les produits
        products.forEach((product) => {
          product.classList.remove('hidden');
        });
      } else {
        // Filtres actifs : filtrer par rareté
        products.forEach((product) => {
          const productRarity = product.getAttribute('data-product-rarity');

          if (activeRarities.has(productRarity)) {
            product.classList.remove('hidden');
          } else {
            product.classList.add('hidden');
          }
        });
      }
    }

    rarityFilters.forEach((filter) => {
      filter.addEventListener('click', function (event) {
        event.stopPropagation();

        const rarity = this.getAttribute('data-rarity');

        // Toggle le filtre
        if (activeRarities.has(rarity)) {
          activeRarities.delete(rarity);
          this.classList.remove('active');
        } else {
          activeRarities.add(rarity);
          this.classList.add('active');
        }

        // Mettre à jour le filtrage des produits
        filterProducts();
      });
    });

    // Gestion du menu de tri
    const settingsBtn = document.querySelector('[data-settings-btn]');
    const settingsMenu = document.querySelector('[data-settings-menu]');

    if (settingsBtn && settingsMenu) {
      settingsBtn.addEventListener('click', function (event) {
        event.stopPropagation();
        settingsMenu.classList.toggle('is-open');
        settingsBtn.classList.toggle('is-active');
      });

      // Fermer le menu si on clique ailleurs
      document.addEventListener('click', function () {
        settingsMenu.classList.remove('is-open');
        settingsBtn.classList.remove('is-active');
      });

      // Empêcher la fermeture si on clique sur le menu
      settingsMenu.addEventListener('click', function (event) {
        event.stopPropagation();
      });
    }

    // Gestion du tri par options
    const sortOptions = document.querySelectorAll('.master-page__settings-option');
    const productGrid = document.querySelector('.master-page__grid');
    let currentSort = {}; // { type: 'price'|'rarity'|'az', direction: 'down'|'up' }

    // Sauvegarder l'ordre initial des produits au chargement de la page
    let initialProductOrder = [];
    if (productGrid) {
      initialProductOrder = Array.from(productGrid.querySelectorAll('.collection__product'));
    }

    sortOptions.forEach((option) => {
      option.addEventListener('click', function (event) {
        event.stopPropagation();

        const sortType = this.getAttribute('data-sort');
        const chevronUp = this.querySelector('.master-page__settings-chevron--up');
        const chevronDown = this.querySelector('.master-page__settings-chevron--down');

        // Vérifier l'état actuel de cette option
        const hasActiveChevron =
          chevronUp.classList.contains('is-active') || chevronDown.classList.contains('is-active');

        if (!hasActiveChevron) {
          // Premier clic : activer chevron down (par défaut)
          // Désactiver tous les autres chevrons
          sortOptions.forEach((opt) => {
            opt.querySelectorAll('.master-page__settings-chevron').forEach((c) => c.classList.remove('is-active'));
          });

          chevronDown.classList.add('is-active');
          currentSort = { type: sortType, direction: 'down' };
        } else if (chevronDown.classList.contains('is-active')) {
          // Deuxième clic : passer à chevron up
          chevronDown.classList.remove('is-active');
          chevronUp.classList.add('is-active');
          currentSort = { type: sortType, direction: 'up' };
        } else {
          // Troisième clic : revenir à chevron down
          chevronUp.classList.remove('is-active');
          chevronDown.classList.add('is-active');
          currentSort = { type: sortType, direction: 'down' };
        }

        // Trier les produits
        sortProducts(currentSort);
      });
    });

    function sortProducts(sort) {
      if (!productGrid) return;

      let products = [];

      if (!sort || !sort.type) {
        // Pas de tri, rétablir l'ordre original sauvegardé au chargement
        products = [...initialProductOrder];
      } else {
        products = Array.from(productGrid.querySelectorAll('.collection__product'));
        products.sort((a, b) => {
          let compareValue = 0;

          switch (sort.type) {
            case 'price':
              const priceA = parseFloat(a.getAttribute('data-product-price'));
              const priceB = parseFloat(b.getAttribute('data-product-price'));
              compareValue = priceA - priceB;
              break;

            case 'rarity':
              const rarityOrder = { mythique: 4, legendary: 3, epique: 2, rare: 1 };
              const rarityA = rarityOrder[a.getAttribute('data-product-rarity')] || 0;
              const rarityB = rarityOrder[b.getAttribute('data-product-rarity')] || 0;
              compareValue = rarityA - rarityB;
              break;

            case 'az':
              const titleA = a.getAttribute('data-product-title') || '';
              const titleB = b.getAttribute('data-product-title') || '';
              compareValue = titleA.localeCompare(titleB);
              break;
          }

          // Inverser si direction down
          return sort.direction === 'down' ? compareValue : -compareValue;
        });
      }

      // Réorganiser le DOM (en gardant l'image shadow en premier)
      const shadowImage = productGrid.querySelector('.master-page__grid-shadow');
      products.forEach((product) => {
        productGrid.appendChild(product);
      });

      // Mettre à jour la classe du bouton de tri
      updateSortButtonState();
    }

    // Mettre à jour l'état du bouton de tri
    function updateSortButtonState() {
      const settingsBtn = document.querySelector('[data-settings-btn]');
      if (!settingsBtn) return;

      const hasActiveSort =
        sortOptions &&
        Array.from(sortOptions).some((opt) => {
          const chevronUp = opt.querySelector('.master-page__settings-chevron--up');
          const chevronDown = opt.querySelector('.master-page__settings-chevron--down');
          return chevronUp?.classList.contains('is-active') || chevronDown?.classList.contains('is-active');
        });

      if (hasActiveSort) {
        settingsBtn.classList.add('has-active-sort');
      } else {
        settingsBtn.classList.remove('has-active-sort');
      }
    }

    // Gérer le clic sur le badge de suppression du tri
    const clearSortBadge = document.querySelector('[data-clear-sort]');
    if (clearSortBadge) {
      clearSortBadge.addEventListener('click', function (event) {
        event.stopPropagation();

        // Désactiver tous les chevrons
        sortOptions.forEach((opt) => {
          opt.querySelectorAll('.master-page__settings-chevron').forEach((c) => c.classList.remove('is-active'));
        });

        // Réinitialiser le tri
        currentSort = {};
        sortProducts(null);

        // Mettre à jour l'état du bouton
        updateSortButtonState();
      });
    }
  });
  
  document.addEventListener('DOMContentLoaded', function() {
    const ctaBanner = document.querySelector('[data-cta-banner]');
    const ctaClose = document.querySelector('[data-cta-close]');

    if (ctaBanner) {
      // Show CTA with slide-in animation after 10 seconds
      setTimeout(function() {
        ctaBanner.classList.add('show');
      }, 10000);
    }

    if (ctaClose && ctaBanner) {
      ctaClose.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        ctaBanner.style.display = 'none';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const carousel = document.querySelector('[data-media-carousel]');
    if (!carousel) return;

    const slides = carousel.querySelectorAll('.media-carousel__slide');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');

    if (slides.length === 0) return;

    // Single slide: only init play button, skip carousel logic
    if (slides.length === 1) {
      const playBtn = slides[0].querySelector('[data-play-btn]');
      if (playBtn) {
        playBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          const video = slides[0].querySelector('video');
          if (video) {
            if (video.paused) {
              video.play();
              slides[0].classList.add('media-carousel__slide--playing');
            } else {
              video.pause();
              slides[0].classList.remove('media-carousel__slide--playing');
            }
          }
        });
      }
      return;
    }

    let currentIndex = 0;

    function updateSlides() {
      slides.forEach(function(slide, index) {
        // Remove all position classes
        slide.classList.remove(
          'media-carousel__slide--far-prev',
          'media-carousel__slide--prev',
          'media-carousel__slide--active',
          'media-carousel__slide--next',
          'media-carousel__slide--far-next'
        );

        const diff = index - currentIndex;

        if (diff === 0) {
          slide.classList.add('media-carousel__slide--active');
        } else if (diff === -1 || (currentIndex === 0 && index === slides.length - 1)) {
          slide.classList.add('media-carousel__slide--prev');
        } else if (diff === 1 || (currentIndex === slides.length - 1 && index === 0)) {
          slide.classList.add('media-carousel__slide--next');
        } else if (diff === -2 || (currentIndex <= 1 && index === slides.length - 2 + currentIndex)) {
          slide.classList.add('media-carousel__slide--far-prev');
        } else if (diff === 2 || (currentIndex >= slides.length - 2 && index === currentIndex - slides.length + 2)) {
          slide.classList.add('media-carousel__slide--far-next');
        }
      });

      // Pause all videos except active
      slides.forEach(function(slide, index) {
        const video = slide.querySelector('video');
        if (video) {
          if (index !== currentIndex) {
            video.pause();
            slide.classList.remove('media-carousel__slide--playing');
          }
        }
      });
    }

    function goToSlide(index) {
      if (index < 0) {
        currentIndex = slides.length - 1;
      } else if (index >= slides.length) {
        currentIndex = 0;
      } else {
        currentIndex = index;
      }
      updateSlides();
    }

    function nextSlide() {
      goToSlide(currentIndex + 1);
    }

    function prevSlide() {
      goToSlide(currentIndex - 1);
    }

    // Arrow navigation
    if (prevBtn) prevBtn.addEventListener('click', prevSlide);
    if (nextBtn) nextBtn.addEventListener('click', nextSlide);

    // Click on slide to make it active
    slides.forEach(function(slide, index) {
      slide.addEventListener('click', function(e) {
        if (index !== currentIndex && !e.target.closest('[data-play-btn]')) {
          goToSlide(index);
        }
      });
    });

    // Play button for videos
    const playBtns = carousel.querySelectorAll('[data-play-btn]');
    playBtns.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        const slide = this.closest('.media-carousel__slide');
        const video = slide.querySelector('video');
        if (video) {
          if (video.paused) {
            video.play();
            slide.classList.add('media-carousel__slide--playing');
          } else {
            video.pause();
            slide.classList.remove('media-carousel__slide--playing');
          }
        }
      });
    });

    // Touch/swipe support
    let touchStartX = 0;
    let touchEndX = 0;

    carousel.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    carousel.addEventListener('touchend', function(e) {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });

    function handleSwipe() {
      const swipeThreshold = 50;
      const diff = touchStartX - touchEndX;

      if (Math.abs(diff) > swipeThreshold) {
        if (diff > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }
    }

    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (e.key === 'ArrowLeft') {
        prevSlide();
      } else if (e.key === 'ArrowRight') {
        nextSlide();
      }
    });

    // Initialize
    updateSlides();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partner-carousel"] && !Shopify.designMode) return;
  try {
    
  class PartnerCarousel {
    constructor(element) {
      this.track = element.querySelector('[data-carousel]');
      if (!this.track) return;

      this.position = 0;
      this.speed = this.getSpeed();
      this.animationId = null;
      this.trackWidth = 0;

      this.init();
    }

    getSpeed() {
      // Reduce speed on mobile devices
      const isMobile = window.innerWidth <= 768;
      return isMobile ? 0.25 : 0.5; // 0.25px/frame on mobile, 0.5px/frame on desktop
    }

    init() {
      // Calculate the width of the original items (not including clones)
      this.calculateTrackWidth();

      // Start animation
      this.animate();

      // Recalculate on window resize
      window.addEventListener('resize', () => {
        this.calculateTrackWidth();
        this.speed = this.getSpeed(); // Update speed on resize
      });
    }

    calculateTrackWidth() {
      const items = this.track.querySelectorAll('.partner-carousel__item:not(.partner-carousel__item--clone)');
      let totalWidth = 0;

      items.forEach((item, index) => {
        totalWidth += item.offsetWidth;
        // Add gap width except for the last item
        if (index < items.length - 1) {
          const gap = parseFloat(getComputedStyle(this.track).gap) || 144;
          totalWidth += gap;
        }
      });

      // Add one more gap for the space between last original and first clone
      const gap = parseFloat(getComputedStyle(this.track).gap) || 144;
      totalWidth += gap;

      this.trackWidth = totalWidth;
    }

    animate() {
      this.position -= this.speed;

      // Reset position when we've scrolled through all original items
      if (Math.abs(this.position) >= this.trackWidth) {
        this.position = 0;
      }

      this.track.style.transform = `translateX(${this.position}px)`;

      this.animationId = requestAnimationFrame(() => this.animate());
    }

    destroy() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
      }
    }
  }

  // Initialize all carousels on the page
  document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.partner-carousel');
    carousels.forEach(carousel => new PartnerCarousel(carousel));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-custom-poster"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.getElementById('custom-poster-form');
    const variantInput = document.getElementById('selected-variant-id');
    const previewImage = document.getElementById('poster-preview-image');
    const uploadPlaceholder = document.getElementById('upload-placeholder');
    const uploadlyTrigger = document.querySelector('[data-uploadly-trigger]');

    // Format money helper
    function formatMoney(cents) {
      const amount = (cents / 100).toFixed(2).replace('.', ',');
      return amount + '€';
    }

    // Handle Uploadly trigger button click
    if (uploadlyTrigger) {
      // Track retry attempts
      let retryCount = 0;
      const maxRetries = 3;

      function findAndClickUploadlyButton() {
        console.log('Upload button clicked, searching for Uploadly widget... (attempt ' + (retryCount + 1) + ')');

        // Try multiple selectors to find the Uploadly button
        const selectors = [
          '.uploadcare--widget__button_type_open[data-ph-product-id]',
          '.uploadcare--widget__button_type_open',
          '[data-ph-wrap] button',
          '[data-uploadly-button]',
          '.uploadcare--widget button',
          'button[class*="uploadcare"]',
          // Additional selectors for different Uploadly versions
          '[data-ph-product-id]',
          '.ph-widget button',
          '.ph-button',
          'input[type="file"][accept*="image"]'
        ];

        let uploadlyButton = null;
        for (const selector of selectors) {
          const elements = document.querySelectorAll(selector);
          for (const el of elements) {
            // Skip our own trigger button
            if (el !== uploadlyTrigger && !el.classList.contains('custom-poster__uploadly-trigger')) {
              uploadlyButton = el;
              console.log('Found Uploadly element with selector:', selector, el);
              break;
            }
          }
          if (uploadlyButton) break;
        }

        if (uploadlyButton) {
          uploadlyButton.click();
          console.log('Uploadly button clicked successfully');
          retryCount = 0; // Reset for next click
          return true;
        }

        return false;
      }

      uploadlyTrigger.addEventListener('click', function() {
        if (!findAndClickUploadlyButton()) {
          // Widget not found, try again after a short delay
          if (retryCount < maxRetries) {
            retryCount++;
            console.log('Uploadly widget not found, retrying in 500ms...');
            setTimeout(() => {
              if (!findAndClickUploadlyButton()) {
                if (retryCount >= maxRetries) {
                  console.error('Uploadly widget not found after ' + maxRetries + ' attempts');
                  console.log('Available elements:', document.querySelectorAll('[class*="upload"], [class*="ph-"], [data-ph-wrap]'));
                  alert('L\'application Uploadly n\'est pas disponible sur cette page.\n\nPour activer l\'upload d\'images, veuillez :\n1. Installer l\'app Uploadly depuis le Shopify App Store\n2. Ajouter le bloc Uploadly dans le template de cette page via le Theme Editor');
                  retryCount = 0;
                }
              }
            }, 500);
          }
        }
      });
    }

    // Monitor for uploaded images from Uploadly
    // Priorisiert das Crop-Preview aus dem Uploadcare-Dialog
    // (.uploadcare--media__image), damit die URL mit Crop-Transformation
    // übernommen wird statt eines beliebigen Widget-Thumbnails.
    let lastCapturedSrc = null;

    function checkForUploadedImage() {
      const selectors = [
        // Priorität 1: Crop-Preview aus dem Uploadcare-Dialog (enthält die Crop-Transformation)
        '.uploadcare--media__image.uploadcare--preview__image',
        '.uploadcare-tab-effects--image',
        '.uploadcare--media.uploadcare-tab-effects--image-container img',
        // Fallbacks
        '[id^="previewImages_"] img',
        '[data-ph-wrap] img',
        '.uploadcare--widget img'
      ];

      let uploadedImage = null;
      for (const selector of selectors) {
        const el = document.querySelector(selector);
        if (
          el &&
          el.src &&
          !el.src.includes('data:image') &&
          (el.src.includes('ucarecd') || el.src.includes('ucarecdn'))
        ) {
          uploadedImage = el;
          break;
        }
      }

      if (uploadedImage && previewImage) {
        let src = uploadedImage.src;

        // Rahmen-Orientierung ermitteln (Upload-Zone)
        const frameEl = document.getElementById('custom-poster-upload');
        const frameIsPortrait = frameEl
          ? frameEl.clientHeight >= frameEl.clientWidth
          : true;

        // Crop-Maße aus der URL lesen
        const dimMatch = src.match(/\/-\/crop\/(\d+)x(\d+)\//);

        // Dialog-Preview-URL bereinigen: alles nach dem Crop abschneiden,
        // damit die setfill/Dialog-Verkleinerung nicht übernommen wird.
        // Bei Orientierungs-Mismatch (Querformat-Bild in Hochformat-Rahmen
        // oder umgekehrt) wird das Bild per CDN um 90° gedreht eingefügt,
        // damit keine leeren Stellen in der Preview bleiben.
        const cropMatch = src.match(/^(.*?\/-\/crop\/[^/]+\/[^/]+\/)/);
        if (cropMatch && dimMatch) {
          const w = parseInt(dimMatch[1]);
          const h = parseInt(dimMatch[2]);
          const imgIsPortrait = h >= w;
          const needsRotate = w > 0 && h > 0 && imgIsPortrait !== frameIsPortrait;

          src = cropMatch[1]
            + '-/preview/1400x1400/'
            + (needsRotate ? '-/rotate/90/' : '')
            + '-/format/auto/';
        } else if (cropMatch) {
          src = cropMatch[1] + '-/preview/1400x1400/-/format/auto/';
        }

        if (lastCapturedSrc !== src) {
          lastCapturedSrc = src;
          previewImage.src = src;
          previewImage.classList.add('custom-poster__preview-image--uploaded');
          previewImage.style.display = 'block';
          if (uploadPlaceholder) {
            uploadPlaceholder.style.display = 'none';
          }
          console.log('Image captured from Uploadcare dialog:', src);
        }
      }
    }

    // Check for uploaded images every 500ms
    const uploadCheckInterval = setInterval(checkForUploadedImage, 500);

    // Handle option button selection
    function initOptionButtons() {
      const optionBtns = document.querySelectorAll('.custom-poster__option-btn, .custom-poster__quantity-btn');
      optionBtns.forEach((btn) => {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          const input = this.querySelector('input');
          if (input && input.dataset.optionPosition) {
            // Remove selected class from siblings in same group
            const parent = this.parentElement;
            const siblings = parent.querySelectorAll('.custom-poster__option-btn, .custom-poster__quantity-btn');
            siblings.forEach((sib) => {
              sib.classList.remove('custom-poster__option-btn--selected', 'custom-poster__quantity-btn--selected');
            });

            // Add selected class to this
            if (this.classList.contains('custom-poster__quantity-btn')) {
              this.classList.add('custom-poster__quantity-btn--selected');
            } else {
              this.classList.add('custom-poster__option-btn--selected');
            }
            input.checked = true;

            // Handle custom quantity button
            if (input.value === 'custom') {
              const customInput = document.getElementById('custom-quantity-input');
              if (customInput) {
                customInput.style.display = 'block';
                customInput.focus();
              }
            } else {
              const customInput = document.getElementById('custom-quantity-input');
              if (customInput) {
                customInput.style.display = 'none';
              }
            }

            // Update variant
            updateVariant();
          }
        });
      });
    }

    function updateVariant() {
      if (!window.productVariants || !variantInput) return;

      // Get all selected options by position
      const selectedOptions = {};
      document.querySelectorAll('input[data-option-position]:checked').forEach((input) => {
        const position = parseInt(input.dataset.optionPosition);
        selectedOptions[position] = input.value;
      });

      // Find matching variant
      const variant = window.productVariants.find((v) => {
        let match = true;
        for (const pos in selectedOptions) {
          if (v['option' + pos] !== selectedOptions[pos]) {
            match = false;
            break;
          }
        }
        return match;
      });

      if (variant) {
        // Update hidden variant input
        variantInput.value = variant.id;

        // Update URL without reloading
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        // Update button state and price
        const submitBtn = document.querySelector('.custom-poster__add-btn');
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          const cartText = submitBtn.querySelector('.button__text');
          const priceEl = submitBtn.querySelector('.custom-poster__price');
          if (cartText) {
            if (variant.available) {
              if (priceEl) {
                priceEl.textContent = formatMoney(variant.price);
              } else {
                cartText.innerHTML = 'AJOUTER - <span class="custom-poster__price">' + formatMoney(variant.price) + '</span>';
              }
            } else {
              cartText.textContent = 'Indisponible';
            }
          }
        }

        console.log('Variant selected:', variant.title, '- Price:', formatMoney(variant.price));
      }
    }

    // Handle form submit - AJAX add to cart
    async function handleAddToCart(e) {
      e.preventDefault();

      const submitBtn = document.querySelector('.custom-poster__add-btn');
      const variantId = variantInput ? variantInput.value : null;

      if (!variantId) {
        console.error('No variant selected');
        return;
      }

      // Get uploaded image URLs
      let directImageUrl = null;
      let uploadlyUrl = null;

      // Get direct image URL from our preview image
      if (previewImage && previewImage.classList.contains('custom-poster__preview-image--uploaded')) {
        directImageUrl = previewImage.src;
      }

      // Get Uploadly download URL from hidden input (created by Uploadly)
      const uploadlyInput = document.querySelector('input[name*="properties"][data-cdn]');
      if (uploadlyInput && uploadlyInput.value) {
        uploadlyUrl = uploadlyInput.value;
      }

      console.log('Direct image URL:', directImageUrl);
      console.log('Uploadly URL:', uploadlyUrl);

      // Disable button and show loading state
      if (submitBtn) {
        submitBtn.disabled = true;
        const cartText = submitBtn.querySelector('.button__text');
        if (cartText) {
          cartText.textContent = 'Ajout en cours...';
        }
      }

      // Build cart item data
      const cartData = {
        id: parseInt(variantId),
        quantity: 1,
      };

      // Add image as line item properties if uploaded
      // - 'custom poster': Uploadly URL (visible to customer, for download)
      // - '_custom poster image': Direct image URL (hidden from customer, for display in cart)
      if (directImageUrl || uploadlyUrl) {
        cartData.properties = {};
        if (uploadlyUrl) {
          cartData.properties['custom poster'] = uploadlyUrl;
        }
        if (directImageUrl) {
          cartData.properties['_custom poster image'] = directImageUrl;
        }
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(cartData),
        });

        if (response.ok) {
          const data = await response.json();

          // Fetch updated cart to get item count
          fetch('/cart.js')
            .then((res) => res.json())
            .then((cart) => {
              // Update cart icon count in header
              const cartCountElement = document.querySelector('[data-cart-count]');
              if (cartCountElement) {
                cartCountElement.textContent = cart.item_count;
                cartCountElement.setAttribute('data-cart-count', cart.item_count);
              }

              // Dispatch cart updated event to trigger drawer reload and open it
              document.dispatchEvent(
                new CustomEvent('cart:updated', {
                  detail: {
                    ...data,
                    openDrawer: true,
                  },
                })
              );
            });

          // Show success feedback
          if (submitBtn) {
            const cartText = submitBtn.querySelector('.button__text');
            if (cartText) {
              cartText.textContent = 'Ajouté !';
              setTimeout(() => {
                // Restore button text with current variant price
                const currentVariantId = variantInput ? parseInt(variantInput.value) : null;
                const currentVariant = window.productVariants.find(v => v.id === currentVariantId);
                if (currentVariant && currentVariant.available) {
                  cartText.innerHTML = 'Ajouter au panier - <span class="custom-poster__price">' + formatMoney(currentVariant.price) + '</span>';
                } else {
                  cartText.textContent = 'Ajouter au panier';
                }
                submitBtn.disabled = false;
              }, 2000);
            }
          }

          console.log('Product added to cart:', data);
        } else {
          const errorData = await response.json();
          console.error('Error adding to cart:', errorData);

          // Show error
          if (submitBtn) {
            const cartText = submitBtn.querySelector('.button__text');
            if (cartText) {
              cartText.textContent = errorData.description || 'Erreur';
              setTimeout(() => {
                // Restore button text with current variant price
                const currentVariantId = variantInput ? parseInt(variantInput.value) : null;
                const currentVariant = window.productVariants.find(v => v.id === currentVariantId);
                if (currentVariant && currentVariant.available) {
                  cartText.innerHTML = 'Ajouter au panier - <span class="custom-poster__price">' + formatMoney(currentVariant.price) + '</span>';
                } else {
                  cartText.textContent = 'Ajouter au panier';
                }
                submitBtn.disabled = false;
              }, 3000);
            }
          }
        }
      } catch (error) {
        console.error('Network error:', error);
        if (submitBtn) {
          submitBtn.disabled = false;
          const cartText = submitBtn.querySelector('.button__text');
          if (cartText) {
            // Restore button text with current variant price
            const currentVariantId = variantInput ? parseInt(variantInput.value) : null;
            const currentVariant = window.productVariants.find(v => v.id === currentVariantId);
            if (currentVariant && currentVariant.available) {
              cartText.innerHTML = 'Ajouter au panier - <span class="custom-poster__price">' + formatMoney(currentVariant.price) + '</span>';
            } else {
              cartText.textContent = 'Ajouter au panier';
            }
          }
        }
      }
    }

    // Photo modal functionality
    function initPhotoModal() {
      const modal = document.querySelector('[data-photo-modal]');
      const modalImage = document.querySelector('[data-modal-image]');
      const photoTriggers = document.querySelectorAll('[data-photo-trigger]');
      const closeButtons = document.querySelectorAll('[data-modal-close]');

      if (!modal || !modalImage) return;

      // Open modal on photo click
      photoTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const src = trigger.dataset.photoSrc;
          const alt = trigger.dataset.photoAlt;
          if (src) {
            modalImage.src = src;
            modalImage.alt = alt || '';
            modal.setAttribute('aria-hidden', 'false');
            document.body.style.overflow = 'hidden';
          }
        });
      });

      // Close modal
      function closeModal() {
        modal.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
        setTimeout(() => {
          modalImage.src = '';
        }, 300);
      }

      closeButtons.forEach((btn) => {
        btn.addEventListener('click', closeModal);
      });

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
          closeModal();
        }
      });
    }

    // Photos grid navigation
    function initPhotosNav() {
      const grid = document.querySelector('[data-photos-grid]');
      const prevBtn = document.querySelector('[data-photos-prev]');
      const nextBtn = document.querySelector('[data-photos-next]');

      if (!grid) return;

      const scrollAmount = 160; // photo width + gap

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          grid.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          grid.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });
      }
    }

    // Initialize
    initOptionButtons();
    initPhotoModal();
    initPhotosNav();

    // Attach form submit handler
    if (form) {
      form.addEventListener('submit', handleAddToCart);
    }

    // Initial variant check on page load
    updateVariant();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-detail"] && !Shopify.designMode) return;
  try {
    
  class Product3DCard {
    constructor() {
      this.card = document.querySelector('[data-card]');
      if (!this.card) return;

      this.rotateX = 0;
      this.rotateY = 0;
      this.isDragging = false;
      this.startX = 0;
      this.startY = 0;
      this.currentX = 0;
      this.currentY = 0;

      this.init();
    }

    init() {
      this.bindEvents();
    }

    bindEvents() {
      // Mouse events
      this.card.addEventListener('mousedown', this.handleMouseDown.bind(this));
      document.addEventListener('mousemove', this.handleMouseMove.bind(this));
      document.addEventListener('mouseup', this.handleMouseUp.bind(this));

      // Touch events
      this.card.addEventListener('touchstart', this.handleTouchStart.bind(this), { passive: false });
      document.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
      document.addEventListener('touchend', this.handleTouchEnd.bind(this));
    }

    handleMouseDown(e) {
      this.isDragging = true;
      this.startX = e.clientX;
      this.startY = e.clientY;
      this.card.style.transition = 'none';
    }

    handleMouseMove(e) {
      if (!this.isDragging) return;

      const deltaX = e.clientX - this.startX;
      const deltaY = e.clientY - this.startY;

      this.rotateY += deltaX * 0.5;
      this.rotateX -= deltaY * 0.5;

      // Limit rotation
      this.rotateX = Math.max(-90, Math.min(90, this.rotateX));

      this.updateTransform();

      this.startX = e.clientX;
      this.startY = e.clientY;
    }

    handleMouseUp() {
      this.isDragging = false;
      this.card.style.transition = 'transform 0.6s cubic-bezier(0.23, 1, 0.32, 1)';
    }

    handleTouchStart(e) {
      if (e.touches.length !== 1) return;

      this.isDragging = true;
      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;
      this.card.style.transition = 'none';
      e.preventDefault();
    }

    handleTouchMove(e) {
      if (!this.isDragging || e.touches.length !== 1) return;

      const deltaX = e.touches[0].clientX - this.startX;
      const deltaY = e.touches[0].clientY - this.startY;

      this.rotateY += deltaX * 0.5;
      this.rotateX -= deltaY * 0.5;

      // Limit rotation
      this.rotateX = Math.max(-90, Math.min(90, this.rotateX));

      this.updateTransform();

      this.startX = e.touches[0].clientX;
      this.startY = e.touches[0].clientY;

      e.preventDefault();
    }

    handleTouchEnd() {
      this.isDragging = false;
      this.card.style.transition = 'transform 0.6s cubic-bezier(0.23, 1, 0.32, 1)';
    }

    updateTransform() {
      this.card.style.transform = `rotateX(${this.rotateX}deg) rotateY(${this.rotateY}deg)`;
    }
  }

  // Initialize when DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new Product3DCard();
    });
  } else {
    new Product3DCard();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    // Load Lottie library
    const lottieScript = document.createElement('script');
    lottieScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/lottie-web/5.12.2/lottie.min.js';
    lottieScript.onload = function () {
      // Initialize Lottie animation
      const lottieContainer = document.querySelector('[data-lottie-chevron]');
      if (lottieContainer && window.lottie) {
        const animationPath = lottieContainer.getAttribute('data-lottie-path');
        window.lottie.loadAnimation({
          container: lottieContainer,
          renderer: 'svg',
          loop: true,
          autoplay: true,
          path: animationPath,
        });
      }
    };
    document.head.appendChild(lottieScript);

    // Image Gallery (Desktop Slider)
    const gallery = document.querySelector('.product-page__gallery');
    if (gallery) {
      const track = gallery.querySelector('[data-desktop-slider-track]');
      const slides = Array.from(gallery.querySelectorAll('.product-page__slide'));
      const prevButton = gallery.querySelector('.product-page__chevron--prev');
      const nextButton = gallery.querySelector('.product-page__chevron--next');
      const thumbnails = gallery.querySelectorAll('.product-page__thumbnail');

      if (slides.length > 1) {
        let currentSlide = 0;

        function updateThumbnails(index) {
          thumbnails.forEach((thumb, i) => {
            if (i === index) {
              thumb.classList.add('product-page__thumbnail--active');
            } else {
              thumb.classList.remove('product-page__thumbnail--active');
            }
          });
        }

        function updateSlider() {
          const offset = -currentSlide * 100;
          track.style.transform = `translateX(${offset}%)`;
          updateThumbnails(currentSlide);
        }

        function goToSlide(index) {
          currentSlide = Math.max(0, Math.min(index, slides.length - 1));
          updateSlider();
        }

        function nextSlide() {
          if (currentSlide < slides.length - 1) {
            goToSlide(currentSlide + 1);
          } else {
            goToSlide(0); // Loop back to start
          }
        }

        function prevSlide() {
          if (currentSlide > 0) {
            goToSlide(currentSlide - 1);
          } else {
            goToSlide(slides.length - 1); // Loop to end
          }
        }

        if (nextButton) {
          nextButton.addEventListener('click', nextSlide);
        }

        if (prevButton) {
          prevButton.addEventListener('click', prevSlide);
        }

        // Thumbnail click handlers
        thumbnails.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            if (index !== currentSlide) {
              goToSlide(index);
            }
          });
        });
      }
    }

    // Mobile Slider
    const mobileSlider = document.querySelector('[data-mobile-slider]');
    if (mobileSlider) {
      const track = mobileSlider.querySelector('[data-slider-track]');
      const slides = Array.from(mobileSlider.querySelectorAll('.product-page__mobile-slide'));
      const progressBar = mobileSlider.querySelector('[data-mobile-progress-bar]');

      let currentSlide = 0;
      let startX = 0;
      let currentX = 0;
      let isDragging = false;

      function updateProgressBar() {
        if (progressBar && slides.length > 1) {
          // Calculate progress: starts partially filled and reaches 100% at the last slide
          // Example: 3 images -> 33%, 66%, 100% | 2 images -> 50%, 100%
          const progress = ((currentSlide + 1) / slides.length) * 100;
          progressBar.style.width = `${progress}%`;
        }
      }

      function updateSlider() {
        const offset = -currentSlide * 100;
        track.style.transform = `translateX(${offset}%)`;
        updateProgressBar();
      }

      function goToSlide(index) {
        currentSlide = Math.max(0, Math.min(index, slides.length - 1));
        updateSlider();
      }

      function nextSlide() {
        if (currentSlide < slides.length - 1) {
          goToSlide(currentSlide + 1);
        }
      }

      function prevSlide() {
        if (currentSlide > 0) {
          goToSlide(currentSlide - 1);
        }
      }

      // Initialize progress bar
      updateProgressBar();

      // Touch/drag events
      track.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
        track.style.transition = 'none';
      });

      track.addEventListener('touchmove', (e) => {
        if (!isDragging) return;
        currentX = e.touches[0].clientX;
        const diff = currentX - startX;
        const offset = -currentSlide * 100 + (diff / track.offsetWidth) * 100;
        track.style.transform = `translateX(${offset}%)`;
      });

      track.addEventListener('touchend', () => {
        if (!isDragging) return;
        isDragging = false;
        track.style.transition = 'transform 0.3s ease';

        const diff = currentX - startX;
        const threshold = track.offsetWidth * 0.2;

        if (diff > threshold && currentSlide > 0) {
          prevSlide();
        } else if (diff < -threshold && currentSlide < slides.length - 1) {
          nextSlide();
        } else {
          updateSlider();
        }
      });

      // Mouse drag for desktop testing
      let hasDragged = false;
      track.addEventListener('mousedown', (e) => {
        startX = e.clientX;
        currentX = e.clientX;
        isDragging = true;
        hasDragged = false;
        track.style.transition = 'none';
        track.style.cursor = 'grabbing';
      });

      document.addEventListener('mousemove', (e) => {
        if (!isDragging) return;
        currentX = e.clientX;
        const diff = Math.abs(currentX - startX);
        if (diff > 5) {
          hasDragged = true;
        }
        const offset = -currentSlide * 100 + ((currentX - startX) / track.offsetWidth) * 100;
        track.style.transform = `translateX(${offset}%)`;
      });

      document.addEventListener('mouseup', () => {
        if (!isDragging) return;
        isDragging = false;
        track.style.transition = 'transform 0.3s ease';
        track.style.cursor = 'grab';

        const diff = currentX - startX;
        const threshold = track.offsetWidth * 0.2;

        if (diff > threshold && currentSlide > 0) {
          prevSlide();
        } else if (diff < -threshold && currentSlide < slides.length - 1) {
          nextSlide();
        } else {
          updateSlider();
        }
      });

      // Initial cursor style
      track.style.cursor = 'grab';
    }

    // Details Modal Management (disabled on mobile)
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const productRight = document.querySelector('[data-product-right]');
    const initialState = document.querySelector('[data-initial-state]');
    const scrolledState = document.querySelector('[data-scrolled-state]');

    if (productRight && initialState && scrolledState && !isMobile) {
      let isOpen = false;

      function openDetailsModal() {
        if (isOpen) return;
        isOpen = true;
        scrolledState.classList.add('visible');
        initialState.classList.add('hidden');
      }

      function closeDetailsModal() {
        if (!isOpen) return;
        isOpen = false;
        scrolledState.classList.remove('visible');
        initialState.classList.remove('hidden');
      }

      // More info button click handler
      const moreInfoBtn = document.querySelector('.product-page__more-info');
      if (moreInfoBtn) {
        moreInfoBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          openDetailsModal();
        });
      }

      // Close button click handler
      const closeBtn = document.querySelector('[data-details-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          closeDetailsModal();
        });
      }

      // Close when clicking outside the modal panel
      productRight.addEventListener('click', function (e) {
        if (!isOpen) return;

        // Check if click is inside the modal panel
        if (!scrolledState.contains(e.target)) {
          closeDetailsModal();
        }
      });

      // Close on Escape key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && isOpen) {
          closeDetailsModal();
        }
      });
    }

    // Add to Cart AJAX functionality
    const productForms = document.querySelectorAll(
      '.product-page__form, .product-page__form-compact, .product-page__form-mobile'
    );

    productForms.forEach((form) => {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();

        const formData = new FormData(form);
        const variantId = formData.get('id');

        const submitButton = form.querySelector('button[type="submit"]');
        const originalText = submitButton ? submitButton.querySelector('.button__text').textContent : '';

        // Disable button during submission
        if (submitButton) {
          submitButton.disabled = true;
        }

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
            }),
          });

          if (response.ok) {
            const data = await response.json();

            // Show success feedback
            if (submitButton) {
              submitButton.querySelector('.button__text').textContent = 'Ajouté';
              setTimeout(() => {
                submitButton.querySelector('.button__text').textContent = originalText;
                submitButton.disabled = false;
              }, 2000);
            }

            // Dispatch cart updated event — le drawer recharge et met à jour le badge
            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                detail: {
                  ...data,
                  openDrawer: true,
                },
              })
            );
          } else {
            const errorData = await response.json();
            console.error('Cart add error:', errorData);
            throw new Error(errorData.description || 'Failed to add to cart');
          }
        } catch (error) {
          console.error('Error adding to cart:', error);

          // Show error feedback
          if (submitButton) {
            submitButton.querySelector('.button__text').textContent = 'Erreur';
            setTimeout(() => {
              submitButton.querySelector('.button__text').textContent = originalText;
              submitButton.disabled = false;
            }, 2000);
          }
        }
      });
    });

    // Accordion Functionality
    const accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');

    // Separate desktop and mobile accordions
    const desktopAccordions = document.querySelector('.product-page__accordions');
    const mobileAccordions = document.querySelector('.product-page__accordions--mobile');

    // Ouvrir le premier accordéon par défaut (desktop)
    if (desktopAccordions) {
      const firstDesktopTrigger = desktopAccordions.querySelector('[data-accordion-trigger]');
      if (firstDesktopTrigger) {
        const firstContent = firstDesktopTrigger.parentElement.querySelector('[data-accordion-content]');
        if (firstContent) {
          firstContent.classList.add('open');
          firstDesktopTrigger.classList.add('active');
        }
      }
    }

    // Ouvrir le premier accordéon par défaut (mobile)
    if (mobileAccordions) {
      const firstMobileTrigger = mobileAccordions.querySelector('[data-accordion-trigger]');
      if (firstMobileTrigger) {
        const firstContent = firstMobileTrigger.parentElement.querySelector('[data-accordion-content]');
        if (firstContent) {
          firstContent.classList.add('open');
          firstMobileTrigger.classList.add('active');
        }
      }
    }

    accordionTriggers.forEach((trigger) => {
      trigger.addEventListener('click', function () {
        const content = this.parentElement.querySelector('[data-accordion-content]');
        const isOpen = content.classList.contains('open');

        // Determine if we're in desktop or mobile accordions
        const isDesktop = this.closest('.product-page__accordions');
        const isMobile = this.closest('.product-page__accordions--mobile');

        // Close all accordions in the same group
        if (isDesktop) {
          desktopAccordions.querySelectorAll('[data-accordion-content]').forEach((item) => {
            item.classList.remove('open');
          });
          desktopAccordions.querySelectorAll('[data-accordion-trigger]').forEach((item) => {
            item.classList.remove('active');
          });
        } else if (isMobile) {
          mobileAccordions.querySelectorAll('[data-accordion-content]').forEach((item) => {
            item.classList.remove('open');
          });
          mobileAccordions.querySelectorAll('[data-accordion-trigger]').forEach((item) => {
            item.classList.remove('active');
          });
        }

        // Toggle current accordion
        if (!isOpen) {
          content.classList.add('open');
          this.classList.add('active');
        }
      });
    });
  })();

  // Add to cart via AJAX
  (function () {
    const form = document.querySelector('.product-page__form');

    if (form) {
      form.addEventListener('submit', async function (e) {
        e.preventDefault();

        const formData = new FormData(this);
        const submitButton = this.querySelector('button[type="submit"]');
        const originalText = submitButton.textContent;

        // Disable button during submission
        submitButton.disabled = true;

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              id: formData.get('id'),
              quantity: 1,
            }),
          });

          if (response.ok) {
            const data = await response.json();

            // Update cart count in header
            const cartCount = document.querySelector('[data-cart-count]');
            const cartResponse = await fetch('/cart.js');
            const cart = await cartResponse.json();

            if (cartCount) {
              cartCount.textContent = cart.item_count;
              if (cart.item_count > 0) {
                cartCount.style.display = 'flex';
              }
            }

            // Dispatch custom event to update cart drawer and open it
            document.dispatchEvent(
              new CustomEvent('cart:updated', {
                detail: {
                  ...cart,
                  openDrawer: true,
                },
              })
            );

            // Show success feedback
            submitButton.textContent = 'Ajouté';

            // Reset button after 2 seconds
            setTimeout(() => {
              submitButton.disabled = false;
              submitButton.textContent = originalText;
            }, 2000);
          } else {
            throw new Error('Failed to add to cart');
          }
        } catch (error) {
          console.error('Error adding to cart:', error);
          submitButton.textContent = 'Erreur';

          setTimeout(() => {
            submitButton.disabled = false;
            submitButton.textContent = originalText;
          }, 2000);
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-accordion"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // Accordion functionality
    const accordionTriggers = document.querySelectorAll('.reviews-accordion-section [data-accordion-trigger]');

    // Open first accordion by default
    const firstTrigger = document.querySelector('.reviews-accordion-section [data-accordion-trigger]');
    if (firstTrigger) {
      const firstContent = firstTrigger.parentElement.querySelector('[data-accordion-content]');
      if (firstContent) {
        firstContent.classList.add('open');
        firstTrigger.classList.add('active');
      }
    }

    accordionTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function() {
        const content = this.parentElement.querySelector('[data-accordion-content]');
        const isOpen = content.classList.contains('open');

        // Close all accordions in this section
        const section = this.closest('.reviews-accordion-section');
        section.querySelectorAll('[data-accordion-content]').forEach(function(item) {
          item.classList.remove('open');
        });
        section.querySelectorAll('[data-accordion-trigger]').forEach(function(item) {
          item.classList.remove('active');
        });

        // Toggle current accordion
        if (!isOpen) {
          content.classList.add('open');
          this.classList.add('active');
        }
      });
    });

    // Show more reviews button
    const showMoreWrapper = document.querySelector('[data-show-more-reviews]');
    if (showMoreWrapper) {
      const showMoreBtn = showMoreWrapper.querySelector('.button');
      const section = showMoreWrapper.closest('.reviews-accordion-section');

      if (showMoreBtn && section) {
        showMoreBtn.addEventListener('click', function() {
          section.classList.add('is-expanded');
          showMoreWrapper.style.display = 'none';
        });
      }
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const carousel = document.querySelector('[data-reviews-carousel]');
    if (!carousel) return;

    const track = carousel.querySelector('[data-reviews-track]');
    if (!track) return;

    const items = track.querySelectorAll('.reviews-carousel__item');
    if (items.length === 0) return;

    // Clone items for infinite scroll
    items.forEach(function (item) {
      const clone = item.cloneNode(true);
      track.appendChild(clone);
    });

    // Image Modal
    const modal = carousel.querySelector('[data-review-image-modal]');
    const modalImage = carousel.querySelector('[data-review-modal-image]');
    const closeButtons = carousel.querySelectorAll('[data-review-modal-close]');

    if (modal && modalImage) {
      function openModal(imageUrl) {
        modalImage.src = imageUrl;
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        setTimeout(function() {
          modalImage.src = '';
        }, 300);
      }

      // Use event delegation for image triggers (handles cloned elements too)
      carousel.addEventListener('click', function(e) {
        const trigger = e.target.closest('[data-review-image-trigger]');
        if (trigger) {
          const imageUrl = trigger.dataset.imageUrl;
          if (imageUrl) {
            openModal(imageUrl);
          }
        }
      });

      closeButtons.forEach(function(btn) {
        btn.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-list"] && !Shopify.designMode) return;
  try {
    
  function initReviewsCarousel() {
    const section = document.querySelector('[data-reviews-list]');
    if (!section) return;

    const carousel = section.querySelector('[data-reviews-carousel]');
    const pagination = section.querySelector('[data-carousel-pagination]');

    // Carousel pagination
    if (carousel && pagination) {
      const dots = pagination.querySelectorAll('[data-carousel-dot]');
      const slides = carousel.querySelectorAll('[data-carousel-slide]');

      if (dots.length > 0 && slides.length > 0) {
        function updateActiveDot() {
          const scrollLeft = carousel.scrollLeft;
          const containerWidth = carousel.offsetWidth;

          let activeIndex = 0;
          let minDistance = Infinity;

          slides.forEach((slide, index) => {
            const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
            const containerCenter = scrollLeft + containerWidth / 2;
            const distance = Math.abs(slideCenter - containerCenter);

            if (distance < minDistance) {
              minDistance = distance;
              activeIndex = index;
            }
          });

          dots.forEach((dot, index) => {
            dot.classList.toggle('reviews-list__dot--active', index === activeIndex);
          });
        }

        dots.forEach((dot) => {
          dot.addEventListener('click', () => {
            const index = parseInt(dot.dataset.carouselDot, 10);
            const targetSlide = slides[index];
            if (targetSlide) {
              const scrollPosition = targetSlide.offsetLeft - (carousel.offsetWidth - targetSlide.offsetWidth) / 2;
              carousel.scrollTo({ left: scrollPosition, behavior: 'smooth' });
            }
          });
        });

        let scrollTimeout;
        carousel.addEventListener('scroll', () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(updateActiveDot, 50);
        });

        updateActiveDot();
      }
    }

    // Image Modal
    const modal = section.querySelector('[data-review-image-modal]');
    const modalImage = section.querySelector('[data-review-modal-image]');
    const imageTriggers = section.querySelectorAll('[data-review-image-trigger]');
    const closeButtons = section.querySelectorAll('[data-review-modal-close]');

    if (modal && modalImage && imageTriggers.length > 0) {
      function openModal(imageUrl) {
        modalImage.src = imageUrl;
        modal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      }

      function closeModal() {
        modal.classList.remove('is-open');
        document.body.style.overflow = '';
        setTimeout(() => {
          modalImage.src = '';
        }, 300);
      }

      imageTriggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
          const imageUrl = trigger.dataset.imageUrl;
          if (imageUrl) {
            openModal(imageUrl);
          }
        });
      });

      closeButtons.forEach((btn) => {
        btn.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) {
          closeModal();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewsCarousel);
  } else {
    initReviewsCarousel();
  }

  } catch(e) { console.error(e); }
})();
})();
